/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
};

export type AdministrationTeam = Team & {
  __typename?: "AdministrationTeam";
  id: Scalars["ID"]["output"];
  members: Array<User>;
  name: Scalars["String"]["output"];
};

export type Apartment = RecordInterface & {
  __typename?: "Apartment";
  activeServiceCasesCount: Scalars["Int"]["output"];
  address: Scalars["String"]["output"];
  archived?: Maybe<Scalars["Boolean"]["output"]>;
  availableFieldGroups: Array<FieldGroup>;
  canUpdate: Scalars["Boolean"]["output"];
  cases: CaseList;
  city: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  currentTenancy?: Maybe<Tenancy>;
  documents?: Maybe<Array<Document>>;
  fieldGroups: Array<ApartmentFieldGroup>;
  id: Scalars["ID"]["output"];
  inactive?: Maybe<Scalars["Boolean"]["output"]>;
  inactiveDescription?: Maybe<Scalars["String"]["output"]>;
  inactiveEndDate?: Maybe<Scalars["String"]["output"]>;
  inactiveStartDate?: Maybe<Scalars["String"]["output"]>;
  key?: Maybe<Scalars["String"]["output"]>;
  messages: MessageList;
  nextTenancy?: Maybe<Tenancy>;
  occupancy: Array<Tenancy>;
  postalCode: Scalars["String"]["output"];
  previousTenancy?: Maybe<Tenancy>;
  property: Property;
  publicId: Scalars["String"]["output"];
  tenancies: TenancyList;
  tenancy?: Maybe<Tenancy>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type ApartmentCasesArgs = {
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type ApartmentMessagesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<MessageOrderByEnum>;
  where?: InputMaybe<MessageWhereInput>;
};

export type ApartmentOccupancyArgs = {
  within: AvailableWithinInput;
};

export type ApartmentTenancyArgs = {
  id: Scalars["ID"]["input"];
};

export type ApartmentFieldGroup = {
  __typename?: "ApartmentFieldGroup";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  values: Array<FieldValue>;
};

export type ApartmentList = {
  __typename?: "ApartmentList";
  availability: Array<Availability>;
  count: Scalars["Int"]["output"];
  records: Array<Apartment>;
  total: Scalars["Int"]["output"];
};

export type ApartmentListAvailabilityArgs = {
  within: AvailableWithinInput;
};

export enum ApartmentOrderByEnum {
  AddressAsc = "address_ASC",
  AddressDesc = "address_DESC",
  CityAsc = "city_ASC",
  CityDesc = "city_DESC",
  CurrentTenantCprAsc = "currentTenantCpr_ASC",
  CurrentTenantCprDesc = "currentTenantCpr_DESC",
  CurrentTenantDepositAmountAsc = "currentTenantDepositAmount_ASC",
  CurrentTenantDepositAmountDesc = "currentTenantDepositAmount_DESC",
  CurrentTenantDepositDueDateAsc = "currentTenantDepositDueDate_ASC",
  CurrentTenantDepositDueDateDesc = "currentTenantDepositDueDate_DESC",
  CurrentTenantEmailAsc = "currentTenantEmail_ASC",
  CurrentTenantEmailDesc = "currentTenantEmail_DESC",
  CurrentTenantEndDateAsc = "currentTenantEndDate_ASC",
  CurrentTenantEndDateDesc = "currentTenantEndDate_DESC",
  CurrentTenantNameAsc = "currentTenantName_ASC",
  CurrentTenantNameDesc = "currentTenantName_DESC",
  CurrentTenantPhoneAsc = "currentTenantPhone_ASC",
  CurrentTenantPhoneDesc = "currentTenantPhone_DESC",
  CurrentTenantRequestedEndDateAsc = "currentTenantRequestedEndDate_ASC",
  CurrentTenantRequestedEndDateDesc = "currentTenantRequestedEndDate_DESC",
  CurrentTenantStartDateAsc = "currentTenantStartDate_ASC",
  CurrentTenantStartDateDesc = "currentTenantStartDate_DESC",
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  NextTenantCprAsc = "nextTenantCpr_ASC",
  NextTenantCprDesc = "nextTenantCpr_DESC",
  NextTenantDepositAmountAsc = "nextTenantDepositAmount_ASC",
  NextTenantDepositAmountDesc = "nextTenantDepositAmount_DESC",
  NextTenantDepositDueDateAsc = "nextTenantDepositDueDate_ASC",
  NextTenantDepositDueDateDesc = "nextTenantDepositDueDate_DESC",
  NextTenantEmailAsc = "nextTenantEmail_ASC",
  NextTenantEmailDesc = "nextTenantEmail_DESC",
  NextTenantEndDateAsc = "nextTenantEndDate_ASC",
  NextTenantEndDateDesc = "nextTenantEndDate_DESC",
  NextTenantNameAsc = "nextTenantName_ASC",
  NextTenantNameDesc = "nextTenantName_DESC",
  NextTenantPhoneAsc = "nextTenantPhone_ASC",
  NextTenantPhoneDesc = "nextTenantPhone_DESC",
  NextTenantRequestedEndDateAsc = "nextTenantRequestedEndDate_ASC",
  NextTenantRequestedEndDateDesc = "nextTenantRequestedEndDate_DESC",
  NextTenantStartDateAsc = "nextTenantStartDate_ASC",
  NextTenantStartDateDesc = "nextTenantStartDate_DESC",
  OwnerAsc = "owner_ASC",
  OwnerDesc = "owner_DESC",
  PreviousTenantCprAsc = "previousTenantCpr_ASC",
  PreviousTenantCprDesc = "previousTenantCpr_DESC",
  PreviousTenantDepositAmountAsc = "previousTenantDepositAmount_ASC",
  PreviousTenantDepositAmountDesc = "previousTenantDepositAmount_DESC",
  PreviousTenantDepositDueDateAsc = "previousTenantDepositDueDate_ASC",
  PreviousTenantDepositDueDateDesc = "previousTenantDepositDueDate_DESC",
  PreviousTenantEmailAsc = "previousTenantEmail_ASC",
  PreviousTenantEmailDesc = "previousTenantEmail_DESC",
  PreviousTenantEndDateAsc = "previousTenantEndDate_ASC",
  PreviousTenantEndDateDesc = "previousTenantEndDate_DESC",
  PreviousTenantNameAsc = "previousTenantName_ASC",
  PreviousTenantNameDesc = "previousTenantName_DESC",
  PreviousTenantPhoneAsc = "previousTenantPhone_ASC",
  PreviousTenantPhoneDesc = "previousTenantPhone_DESC",
  PreviousTenantRequestedEndDateAsc = "previousTenantRequestedEndDate_ASC",
  PreviousTenantRequestedEndDateDesc = "previousTenantRequestedEndDate_DESC",
  PreviousTenantStartDateAsc = "previousTenantStartDate_ASC",
  PreviousTenantStartDateDesc = "previousTenantStartDate_DESC",
  PropertyAsc = "property_ASC",
  PropertyDesc = "property_DESC",
  PublicIdAsc = "publicId_ASC",
  PublicIdDesc = "publicId_DESC",
}

export enum ApartmentStatusEnum {
  Active = "active",
  Archived = "archived",
}

/** Autogenerated return type of ApartmentUpdateMutation. */
export type ApartmentUpdateMutationPayload = {
  __typename?: "ApartmentUpdateMutationPayload";
  apartment?: Maybe<Apartment>;
  errors: Array<Scalars["String"]["output"]>;
};

export type ApartmentWhereInput = {
  activeCases?: InputMaybe<Scalars["Boolean"]["input"]>;
  byArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAvailableWithin?: InputMaybe<AvailableWithinInput>;
  byOwner?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byStatus?: InputMaybe<Array<ApartmentStatusEnum>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type AttachmentCategory = {
  __typename?: "AttachmentCategory";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  nameDa: Scalars["String"]["output"];
  nameEn: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type Availability = {
  __typename?: "Availability";
  apartmentId: Scalars["ID"]["output"];
  from?: Maybe<Scalars["ISO8601Date"]["output"]>;
  to?: Maybe<Scalars["ISO8601Date"]["output"]>;
};

export type AvailableResponsibleTeam = {
  __typename?: "AvailableResponsibleTeam";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  users: Array<CaseUser>;
};

export type AvailableWithinInput = {
  minDays?: InputMaybe<Scalars["Int"]["input"]>;
  periodEnd?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  periodStart: Scalars["ISO8601Date"]["input"];
  slack?: InputMaybe<Scalars["Int"]["input"]>;
};

export type BankAccount = {
  __typename?: "BankAccount";
  account?: Maybe<Scalars["String"]["output"]>;
  bankName?: Maybe<Scalars["String"]["output"]>;
  reg?: Maybe<Scalars["String"]["output"]>;
};

export type BaseInspectionInput = {
  caseId: Scalars["ID"]["input"];
  cleaning?: InputMaybe<Scalars["String"]["input"]>;
  keys: Array<CaseInspectionKeyInput>;
  landlordSignature?: InputMaybe<Scalars["String"]["input"]>;
  meterReadings: Array<CaseInspectionMeterReadingInput>;
  other?: InputMaybe<Scalars["String"]["input"]>;
  tenantSignature?: InputMaybe<Scalars["String"]["input"]>;
};

export type Case = RecordInterface & {
  __typename?: "Case";
  apartment?: Maybe<Apartment>;
  attention: CaseAttentionEnum;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  children: Array<Case>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspection?: Maybe<Inspection>;
  name: Scalars["String"]["output"];
  parent?: Maybe<Case>;
  property?: Maybe<Property>;
  requester?: Maybe<User>;
  responsible?: Maybe<User>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  type: CaseTypeEnum;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type CaseApplicationInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  leaveDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

export type CaseAttachment = {
  __typename?: "CaseAttachment";
  category?: Maybe<AttachmentCategory>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  fileName: Scalars["String"]["output"];
  fileSize: Scalars["Int"]["output"];
  fileType: Scalars["String"]["output"];
  headSignedUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isImage: Scalars["Boolean"]["output"];
  isPdf: Scalars["Boolean"]["output"];
  largeUrl: Scalars["String"]["output"];
  originalUrl: Scalars["String"]["output"];
  thumbUrl: Scalars["String"]["output"];
};

export type CaseAttentionCondition = {
  __typename?: "CaseAttentionCondition";
  texts: Array<Scalars["String"]["output"]>;
};

export enum CaseAttentionEnum {
  Critical = "critical",
  Important = "important",
  Normal = "normal",
  Success = "success",
}

export type CaseCheck = RecordInterface & {
  __typename?: "CaseCheck";
  case: Case;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CaseCheckInput = {
  _destroy?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseComment = {
  __typename?: "CaseComment";
  assets: Array<File>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  emailMessage: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  important: Scalars["Boolean"]["output"];
  mayReply: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  readAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  recipient?: Maybe<User>;
  sender: User;
  smsMessage: Scalars["Boolean"]["output"];
  stateDescription: Scalars["String"]["output"];
  stateFrom?: Maybe<Scalars["String"]["output"]>;
  stateTo?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<Scalars["String"]["output"]>;
  type: CaseCommentTypeEnum;
};

/** Autogenerated return type of CaseCommentReadMutation. */
export type CaseCommentReadMutationPayload = {
  __typename?: "CaseCommentReadMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
};

export enum CaseCommentTypeEnum {
  /** Cancelled */
  Cancelled = "CANCELLED",
  /** Comment */
  Comment = "COMMENT",
  /** Completed */
  Completed = "COMPLETED",
  /** Created */
  Created = "CREATED",
  /** Message */
  Message = "MESSAGE",
  /** Share Created */
  ShareCreated = "SHARE_CREATED",
  /** Share Revoked */
  ShareRevoked = "SHARE_REVOKED",
  /** Share Sent */
  ShareSent = "SHARE_SENT",
  /** State Changed */
  StateChanged = "STATE_CHANGED",
}

export type CaseCommentUserOption = {
  __typename?: "CaseCommentUserOption";
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
};

export type CaseContractAttributesInput = {
  apartment?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  residents?: InputMaybe<Array<CaseContractResidentInput>>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  tenancyRoles?: InputMaybe<Array<CaseContractRoleInput>>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseContractResidentInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseContractRole = {
  __typename?: "CaseContractRole";
  email?: Maybe<Scalars["String"]["output"]>;
  primary: Scalars["Boolean"]["output"];
};

export type CaseContractRoleInput = {
  email: Scalars["String"]["input"];
  primary: Scalars["Boolean"]["input"];
};

export type CaseContractSettings = {
  __typename?: "CaseContractSettings";
  apartment?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endTenancyTerms?: Maybe<EndTenancyTermsEnum>;
  locale?: Maybe<ContractLocaleEnum>;
  residents: Array<Resident>;
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  tenancyRoles: Array<CaseContractRole>;
  type?: Maybe<ContractTypeEnum>;
};

/** Autogenerated return type of CaseCreateMutation. */
export type CaseCreateMutationPayload = {
  __typename?: "CaseCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseDataAttributesInput = {
  contractAttributes?: InputMaybe<CaseContractAttributesInput>;
  depositAmount?: InputMaybe<Scalars["Int"]["input"]>;
  economic?: InputMaybe<CaseEconomicInput>;
  intervalAmount?: InputMaybe<Scalars["Int"]["input"]>;
  signatures?: InputMaybe<CaseSignaturesInput>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  terminationAttributes?: InputMaybe<CaseDataTerminationAttributesInput>;
};

export type CaseDataTerminationAttributesInput = {
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

export type CaseDefinition = {
  __typename?: "CaseDefinition";
  canCreate: Scalars["Boolean"]["output"];
  cases: CaseList;
  icon: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  states: Array<Scalars["String"]["output"]>;
  type: CaseTypeEnum;
};

export type CaseDefinitionCasesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type CaseEconomicInput = {
  debtor?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Autogenerated return type of CaseEndTenancyUpdateReasonsMutation. */
export type CaseEndTenancyUpdateReasonsMutationPayload = {
  __typename?: "CaseEndTenancyUpdateReasonsMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export enum CaseEventEnum {
  AddAttachment = "add_attachment",
  AddComment = "add_comment",
  AddFollower = "add_follower",
  AddTimelog = "add_timelog",
  Await = "await",
  Cancel = "cancel",
  CancelContract = "cancel_contract",
  CancelScheduled = "cancel_scheduled",
  ChangeContract = "change_contract",
  ChangeEndDate = "change_end_date",
  ChangeResponsible = "change_responsible",
  ChangeServiceTeam = "change_service_team",
  ChangeTask = "change_task",
  Complete = "complete",
  CompleteInspection = "complete_inspection",
  ConfigureRepeat = "configure_repeat",
  Create = "create",
  CreateContract = "create_contract",
  LandlordSignContract = "landlord_sign_contract",
  PopulateContract = "populate_contract",
  ProcessInspection = "process_inspection",
  Receive = "receive",
  RemoveAttachment = "remove_attachment",
  RemoveFollower = "remove_follower",
  Reopen = "reopen",
  RequestTenantInformation = "request_tenant_information",
  Reschedule = "reschedule",
  SaveInspection = "save_inspection",
  Schedule = "schedule",
  SendContract = "send_contract",
  SendTenantInformation = "send_tenant_information",
  Start = "start",
  TenantSignContract = "tenant_sign_contract",
  TenantWillAttendNo = "tenant_will_attend_no",
  TenantWillAttendYes = "tenant_will_attend_yes",
  ToggleCheck = "toggle_check",
  UpdateAttachment = "update_attachment",
  UpdateEconomic = "update_economic",
}

export type CaseEventInput = {
  addFollowerId?: InputMaybe<Scalars["ID"]["input"]>;
  applicationAttributes?: InputMaybe<CaseApplicationInput>;
  attachTenant?: InputMaybe<Scalars["Boolean"]["input"]>;
  attachmentAsset?: InputMaybe<Scalars["String"]["input"]>;
  attachmentCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
  attachmentRemove?: InputMaybe<Scalars["ID"]["input"]>;
  attachmentUpdateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  awaiting?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  cancelledMessage?: InputMaybe<Scalars["String"]["input"]>;
  checkToggleId?: InputMaybe<Scalars["ID"]["input"]>;
  checksAttributes?: InputMaybe<Array<CaseCheckInput>>;
  commentAssets?: InputMaybe<Array<Scalars["String"]["input"]>>;
  commentImportant?: InputMaybe<Scalars["String"]["input"]>;
  commentMessage?: InputMaybe<Scalars["String"]["input"]>;
  commentRecipientId?: InputMaybe<Scalars["ID"]["input"]>;
  completeBefore?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  completedDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  contractData?: InputMaybe<Scalars["JSON"]["input"]>;
  dataAttributes?: InputMaybe<CaseDataAttributesInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endTenancyReasonIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endTenancyReasonNotes?: InputMaybe<Scalars["JSON"]["input"]>;
  removeFollowerId?: InputMaybe<Scalars["ID"]["input"]>;
  repeatPeriod?: InputMaybe<Scalars["String"]["input"]>;
  repeatResponsible?: InputMaybe<Scalars["Boolean"]["input"]>;
  repeatSteps?: InputMaybe<Scalars["Int"]["input"]>;
  responsibleId?: InputMaybe<Scalars["ID"]["input"]>;
  scheduledDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledTime?: InputMaybe<Scalars["String"]["input"]>;
  serviceTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  startAfter?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  template?: InputMaybe<Scalars["ID"]["input"]>;
  timelogAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  timelogCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
  timelogDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  timelogHoursWithoutMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  timelogMinutesWithoutHours?: InputMaybe<Scalars["Int"]["input"]>;
  timelogNote?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseInspectionKeyInput = {
  count: Scalars["Int"]["input"];
  description: Scalars["String"]["input"];
  keyId?: InputMaybe<Scalars["Int"]["input"]>;
  keyMissing?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CaseInspectionMeterReadingInput = {
  id: Scalars["ID"]["input"];
  value: Scalars["Float"]["input"];
};

/** Autogenerated return type of CaseInspectionProcessMutation. */
export type CaseInspectionProcessMutationPayload = {
  __typename?: "CaseInspectionProcessMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

/** Autogenerated return type of CaseInspectionSaveMutation. */
export type CaseInspectionSaveMutationPayload = {
  __typename?: "CaseInspectionSaveMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseInterface = {
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type CaseInterfaceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CaseInterfaceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type CaseList = {
  __typename?: "CaseList";
  count: Scalars["Int"]["output"];
  records: Array<CaseInterface>;
  total: Scalars["Int"]["output"];
};

export enum CaseOrderByEnum {
  ApartmentPublicIdAsc = "apartmentPublicId_ASC",
  ApartmentPublicIdDesc = "apartmentPublicId_DESC",
  ApartmentAsc = "apartment_ASC",
  ApartmentDesc = "apartment_DESC",
  AwaitingAsc = "awaiting_ASC",
  AwaitingDesc = "awaiting_DESC",
  CompleteBeforeAsc = "completeBefore_ASC",
  CompleteBeforeDesc = "completeBefore_DESC",
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  IdAsc = "id_ASC",
  IdDesc = "id_DESC",
  OwnerAsc = "owner_ASC",
  OwnerDesc = "owner_DESC",
  PropertyAsc = "property_ASC",
  PropertyDesc = "property_DESC",
  RequesterAsc = "requester_ASC",
  RequesterDesc = "requester_DESC",
  ScheduledDateAsc = "scheduledDate_ASC",
  ScheduledDateDesc = "scheduledDate_DESC",
  ServiceTeamAsc = "serviceTeam_ASC",
  ServiceTeamDesc = "serviceTeam_DESC",
  StartAfterAsc = "startAfter_ASC",
  StartAfterDesc = "startAfter_DESC",
  StateAsc = "state_ASC",
  StateDesc = "state_DESC",
  TenancyEndDateAsc = "tenancyEndDate_ASC",
  TenancyEndDateDesc = "tenancyEndDate_DESC",
  TenancyStartDateAsc = "tenancyStartDate_ASC",
  TenancyStartDateDesc = "tenancyStartDate_DESC",
  TypeAsc = "type_ASC",
  TypeDesc = "type_DESC",
  UpdatedAtAsc = "updatedAt_ASC",
  UpdatedAtDesc = "updatedAt_DESC",
}

/** Autogenerated return type of CasePlanningUpdateMutation. */
export type CasePlanningUpdateMutationPayload = {
  __typename?: "CasePlanningUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

/** Autogenerated return type of CaseScheduleMutation. */
export type CaseScheduleMutationPayload = {
  __typename?: "CaseScheduleMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseShare = {
  __typename?: "CaseShare";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  deliveries: Array<CaseShareDelivery>;
  description: Scalars["String"]["output"];
  expiresAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  note: Scalars["String"]["output"];
  openedAt: Array<Scalars["ISO8601DateTime"]["output"]>;
  revokedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  selection: CaseShareSelection;
  url: Scalars["String"]["output"];
};

export enum CaseShareChannelEnum {
  /** Email */
  Email = "EMAIL",
  /** SMS */
  Sms = "SMS",
}

/** Autogenerated return type of CaseShareCreateMutation. */
export type CaseShareCreateMutationPayload = {
  __typename?: "CaseShareCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseShare>;
};

export type CaseShareDelivery = {
  __typename?: "CaseShareDelivery";
  channel: CaseShareChannelEnum;
  recipient: Scalars["String"]["output"];
  sentAt: Scalars["ISO8601DateTime"]["output"];
};

export type CaseShareGroup = {
  __typename?: "CaseShareGroup";
  all: Scalars["Boolean"]["output"];
  fieldIds: Array<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type CaseShareGroupInput = {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  fieldIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id: Scalars["ID"]["input"];
};

export type CaseShareGroups = {
  __typename?: "CaseShareGroups";
  apartment: Array<CaseShareGroup>;
  property: Array<CaseShareGroup>;
};

export type CaseShareGroupsInput = {
  apartment?: InputMaybe<Array<CaseShareGroupInput>>;
  property?: InputMaybe<Array<CaseShareGroupInput>>;
};

export type CaseShareItems = {
  __typename?: "CaseShareItems";
  all: Scalars["Boolean"]["output"];
  ids: Array<Scalars["ID"]["output"]>;
};

export type CaseShareItemsInput = {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Autogenerated return type of CaseShareRevokeMutation. */
export type CaseShareRevokeMutationPayload = {
  __typename?: "CaseShareRevokeMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseShare>;
};

export type CaseShareSelection = {
  __typename?: "CaseShareSelection";
  apartment: Scalars["Boolean"]["output"];
  attachments: CaseShareItems;
  case: Scalars["Boolean"]["output"];
  comments: Scalars["Boolean"]["output"];
  documents: CaseShareItems;
  fieldGroups: CaseShareGroups;
  inspection: Scalars["Boolean"]["output"];
  property: Scalars["Boolean"]["output"];
  tenant: Scalars["Boolean"]["output"];
};

export type CaseShareSelectionInput = {
  apartment?: InputMaybe<Scalars["Boolean"]["input"]>;
  attachments?: InputMaybe<CaseShareItemsInput>;
  case?: InputMaybe<Scalars["Boolean"]["input"]>;
  comments?: InputMaybe<Scalars["Boolean"]["input"]>;
  documents?: InputMaybe<CaseShareItemsInput>;
  fieldGroups?: InputMaybe<CaseShareGroupsInput>;
  inspection?: InputMaybe<Scalars["Boolean"]["input"]>;
  property?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenant?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Autogenerated return type of CaseShareSendMutation. */
export type CaseShareSendMutationPayload = {
  __typename?: "CaseShareSendMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseShare>;
};

export type CaseSignature = {
  __typename?: "CaseSignature";
  signature?: Maybe<Scalars["String"]["output"]>;
  signedAt: Scalars["ISO8601Date"]["output"];
  signedBy?: Maybe<Scalars["String"]["output"]>;
  signerRole: Scalars["String"]["output"];
};

export type CaseSignaturesInput = {
  landlordSignature: Scalars["String"]["input"];
};

export enum CaseTypeEnum {
  CleaningService = "cleaning_service",
  CreateTenancy = "create_tenancy",
  EndTenancy = "end_tenancy",
  FindTenancyAdministration = "find_tenancy_administration",
  MiscAdministration = "misc_administration",
  MiscService = "misc_service",
  MovingInService = "moving_in_service",
  MovingInTenancy = "moving_in_tenancy",
  MovingOutService = "moving_out_service",
  MovingOutTenancy = "moving_out_tenancy",
  MovingSettlementAdministration = "moving_settlement_administration",
  PreparationService = "preparation_service",
  RequestTenancy = "request_tenancy",
  StartTenancy = "start_tenancy",
  UtilityAdministration = "utility_administration",
}

/** Autogenerated return type of CaseUpdateMutation. */
export type CaseUpdateMutationPayload = {
  __typename?: "CaseUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseUser = {
  __typename?: "CaseUser";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  protected: Scalars["Boolean"]["output"];
};

export type CaseWhereAndInput = {
  and?: InputMaybe<Array<CaseWhereAndInput>>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAttention?: InputMaybe<CaseAttentionEnum>;
  byState?: InputMaybe<Array<Scalars["String"]["input"]>>;
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<CaseWhereOrInput>>;
  unplanned?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CaseWhereInput = {
  allForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  and?: InputMaybe<Array<CaseWhereAndInput>>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaitingForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  byApartment?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byAssignedServiceTeam?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byAttention?: InputMaybe<CaseAttentionEnum>;
  byParent?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byRequester?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byResponsible?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byServiceTeam?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byState?: InputMaybe<Array<Scalars["String"]["input"]>>;
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  calendarDateRange?: InputMaybe<DateRangeInput>;
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  commentsForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  criticalForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  flaggedForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  importantForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  newForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  notAwaitingForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<CaseWhereOrInput>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  unplanned?: InputMaybe<Scalars["Boolean"]["input"]>;
  withActiveShares?: InputMaybe<Scalars["Boolean"]["input"]>;
  withTenancy?: InputMaybe<Scalars["Boolean"]["input"]>;
  withoutResponsible?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CaseWhereOrInput = {
  and?: InputMaybe<Array<CaseWhereAndInput>>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAttention?: InputMaybe<CaseAttentionEnum>;
  byState?: InputMaybe<Array<Scalars["String"]["input"]>>;
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<CaseWhereOrInput>>;
  unplanned?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CleaningService = CaseInterface & {
  __typename?: "CleaningService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type CleaningServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CleaningServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Company = RecordInterface & {
  __typename?: "Company";
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isAdministrator: Scalars["Boolean"]["output"];
  isOwner: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  vat?: Maybe<Scalars["String"]["output"]>;
};

export type CompanyList = {
  __typename?: "CompanyList";
  count: Scalars["Int"]["output"];
  records: Array<Company>;
  total: Scalars["Int"]["output"];
};

export enum CompanyOrderByEnum {
  AddressAsc = "address_ASC",
  AddressDesc = "address_DESC",
  CityAsc = "city_ASC",
  CityDesc = "city_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
  VatAsc = "vat_ASC",
  VatDesc = "vat_DESC",
}

export type CompanyWhereByPropertyServiceInput = {
  property: Scalars["ID"]["input"];
  service: Scalars["String"]["input"];
};

export type CompanyWhereInput = {
  administrators?: InputMaybe<Scalars["Boolean"]["input"]>;
  byPropertyService?: InputMaybe<CompanyWhereByPropertyServiceInput>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ContractFieldTypeEnum {
  Boolean = "boolean",
  Date = "date",
  Datetime = "datetime",
  Float = "float",
  Integer = "integer",
  String = "string",
}

export type ContractForm = {
  __typename?: "ContractForm";
  sections: Array<ContractFormSection>;
  type: Scalars["String"]["output"];
};

export type ContractFormCondition = {
  __typename?: "ContractFormCondition";
  field: Scalars["String"]["output"];
  is: Scalars["String"]["output"];
};

export type ContractFormField = {
  __typename?: "ContractFormField";
  computed?: Maybe<Scalars["JSON"]["output"]>;
  condition?: Maybe<ContractFormCondition>;
  currency: Scalars["Boolean"]["output"];
  follows?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  multiline: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  options: Array<ContractFormOption>;
  readonly: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
  requiredWhen?: Maybe<ContractFormCondition>;
  suffix?: Maybe<Scalars["String"]["output"]>;
  type: ContractFieldTypeEnum;
};

export type ContractFormOption = {
  __typename?: "ContractFormOption";
  label?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
};

export type ContractFormSection = {
  __typename?: "ContractFormSection";
  fields: Array<ContractFormField>;
  key: Scalars["String"]["output"];
  ordered: Scalars["Boolean"]["output"];
  repeating: Scalars["Boolean"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum ContractLocaleEnum {
  Da = "da",
  En = "en",
}

export type ContractOptions = {
  __typename?: "ContractOptions";
  endTenancyTerms: Array<EndTenancyTermsEnum>;
  locales: Array<ContractLocaleEnum>;
  types: Array<ContractTypeEnum>;
};

export enum ContractTypeEnum {
  ContractA9 = "contract_a9",
  ContractA10 = "contract_a10",
  ContractStandard = "contract_standard",
}

export type CreateTenancy = CaseInterface & {
  __typename?: "CreateTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableDebtorCount: Scalars["Int"]["output"];
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTemplates: Array<DocumentTemplate>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelContract: Scalars["Boolean"]["output"];
  canChangeContract: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canCreateContract: Scalars["Boolean"]["output"];
  canLandlordSignContract: Scalars["Boolean"]["output"];
  canPopulateContract: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canSendContract: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowEndTenancyTerms: Scalars["Boolean"]["output"];
  canShowMovingInCaseResponsible: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  canUpdateEconomic: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  contract?: Maybe<Document>;
  contractForm?: Maybe<ContractForm>;
  contractSettings: CaseContractSettings;
  contractValues?: Maybe<Scalars["JSON"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  daysBetween?: Maybe<Scalars["String"]["output"]>;
  depositAmount?: Maybe<Scalars["Int"]["output"]>;
  displayName: Scalars["String"]["output"];
  economicDebtor?: Maybe<EconomicDebtor>;
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endTenancyTermsText?: Maybe<Scalars["String"]["output"]>;
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  hasCompleteSettings: Scalars["Boolean"]["output"];
  hasEconomicAgreement: Scalars["Boolean"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  intervalAmount?: Maybe<Scalars["Int"]["output"]>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isContractIssued: Scalars["Boolean"]["output"];
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelContract: Scalars["Boolean"]["output"];
  mayChangeContract: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayCreateContract: Scalars["Boolean"]["output"];
  mayLandlordSignContract: Scalars["Boolean"]["output"];
  mayPopulateContract: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  maySendContract: Scalars["Boolean"]["output"];
  mayTenantSignContract: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  mayUpdateEconomic: Scalars["Boolean"]["output"];
  movingInCase?: Maybe<MovingInTenancy>;
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  requiresCprNumber: Scalars["Boolean"]["output"];
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  signatures: Array<CaseSignature>;
  startAfter?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type CreateTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type DateRange = {
  __typename?: "DateRange";
  from?: Maybe<Scalars["String"]["output"]>;
  to?: Maybe<Scalars["String"]["output"]>;
};

export type DateRangeInput = {
  from: Scalars["String"]["input"];
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** Autogenerated return type of DeleteInspectionAnswerMutation. */
export type DeleteInspectionAnswerMutationPayload = {
  __typename?: "DeleteInspectionAnswerMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
};

/** Autogenerated return type of DeletePaymentMutation. */
export type DeletePaymentMutationPayload = {
  __typename?: "DeletePaymentMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

/** Autogenerated return type of DeleteTextMacroMutation. */
export type DeleteTextMacroMutationPayload = {
  __typename?: "DeleteTextMacroMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
};

export type Document = {
  __typename?: "Document";
  contentBase64?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  type: DocumentTypeEnum;
  url: Scalars["String"]["output"];
};

export type DocumentTemplate = {
  __typename?: "DocumentTemplate";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export enum DocumentTypeEnum {
  Contract = "contract",
  Generic = "generic",
  Inspection = "inspection",
  Photo = "photo",
}

export type EconomicDebtor = {
  __typename?: "EconomicDebtor";
  address?: Maybe<Scalars["String"]["output"]>;
  addressText?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  externalId: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type EconomicDebtorList = {
  __typename?: "EconomicDebtorList";
  count: Scalars["Int"]["output"];
  records: Array<EconomicDebtor>;
  total: Scalars["Int"]["output"];
};

export type EconomicDebtorWhereInput = {
  byName?: InputMaybe<Scalars["ID"]["input"]>;
  byTenancy?: InputMaybe<Scalars["ID"]["input"]>;
  withSubscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Autogenerated return type of EconomicResyncMutation. */
export type EconomicResyncMutationPayload = {
  __typename?: "EconomicResyncMutationPayload";
  success: Scalars["Boolean"]["output"];
};

export type EconomicSubscriber = {
  __typename?: "EconomicSubscriber";
  canceledAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  debtor: EconomicDebtor;
  id: Scalars["ID"]["output"];
  intervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  intervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  price: Scalars["Float"]["output"];
  signedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  subscription: EconomicSubscription;
};

export type EconomicSubscriberList = {
  __typename?: "EconomicSubscriberList";
  count: Scalars["Int"]["output"];
  records: Array<EconomicSubscriber>;
  total: Scalars["Int"]["output"];
};

export type EconomicSubscriberWhereInput = {
  byTenancy?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EconomicSubscription = {
  __typename?: "EconomicSubscription";
  id: Scalars["ID"]["output"];
  intervalType?: Maybe<EconomicSubscriptionIntervalEnum>;
  name: Scalars["String"]["output"];
  subscribers: Array<EconomicSubscriber>;
};

export enum EconomicSubscriptionIntervalEnum {
  /** Eight-weekly interval */
  EightWeeks = "EightWeeks",
  /** Penta-yearly interval */
  FiveYears = "FiveYears",
  /** Four-weekly interval */
  FourWeeks = "FourWeeks",
  /** Quad-yearly interval */
  FourYears = "FourYears",
  /** Half-yearly interval */
  HalfYear = "HalfYear",
  /** Monthly interval */
  Month = "Month",
  /** Quarterly interval */
  Quarter = "Quarter",
  /** Tri-yearly interval */
  ThreeYears = "ThreeYears",
  /** Bi-monthly interval */
  TwoMonths = "TwoMonths",
  /** Bi-weekly interval */
  TwoWeeks = "TwoWeeks",
  /** Bi-yearly interval */
  TwoYears = "TwoYears",
  /** Weekly interval */
  Week = "Week",
  /** Yearly interval */
  Year = "Year",
}

export type EconomicSubscriptionList = {
  __typename?: "EconomicSubscriptionList";
  count: Scalars["Int"]["output"];
  records: Array<EconomicSubscription>;
  total: Scalars["Int"]["output"];
};

export type EconomicSubscriptionWhereInput = {
  byName?: InputMaybe<Scalars["String"]["input"]>;
  byOwner?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EndTenancy = CaseInterface & {
  __typename?: "EndTenancy";
  apartment?: Maybe<Apartment>;
  applicationEndDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeEndDate: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowMovingOutCase: Scalars["Boolean"]["output"];
  canShowMovingOutCaseResponsible: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  canUpdateReasons: Scalars["Boolean"]["output"];
  cancelled: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  comment?: Maybe<Scalars["String"]["output"]>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  earlyEndDate: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endDateByTerms?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endDateChanged: Scalars["Boolean"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  lastRentDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  leaveDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeEndDate: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  mayUpdateReasons: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  reasons: Array<EndTenancyReasonSelection>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  terms: TenancyTerms;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type EndTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EndTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

/** Autogenerated return type of EndTenancyMutation. */
export type EndTenancyMutationPayload = {
  __typename?: "EndTenancyMutationPayload";
  case?: Maybe<EndTenancy>;
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type EndTenancyReason = {
  __typename?: "EndTenancyReason";
  id: Scalars["ID"]["output"];
  isOther: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  labelDa: Scalars["String"]["output"];
  labelEn: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
};

export type EndTenancyReasonSelection = {
  __typename?: "EndTenancyReasonSelection";
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
};

export type EndTenancyReasonSelectionInput = {
  id: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export enum EndTenancyTermsEnum {
  Flex_1Month = "flex_1_month",
  Flex_3Months = "flex_3_months",
  FlexNone = "flex_none",
  Standard_1Month = "standard_1_month",
  Standard_1Month_14Days = "standard_1_month_14_days",
  Standard_3Months = "standard_3_months",
  Standard_3Months_14Days = "standard_3_months_14_days",
}

export type Field = RecordInterface & {
  __typename?: "Field";
  availableInApartment: Scalars["Boolean"]["output"];
  availableInHome: Scalars["Boolean"]["output"];
  availableInProperty: Scalars["Boolean"]["output"];
  availableInService: Scalars["Boolean"]["output"];
  availableInTenancy: Scalars["Boolean"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  enumOptions: Array<FieldEnumOption>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameDa: Scalars["String"]["output"];
  nameEn: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  valueType: FieldValueTypeEnum;
};

export type FieldEnumOption = {
  __typename?: "FieldEnumOption";
  id: Scalars["ID"]["output"];
  position: Scalars["Int"]["output"];
  value: Scalars["String"]["output"];
};

export type FieldGroup = {
  __typename?: "FieldGroup";
  fields: Array<Field>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameDa: Scalars["String"]["output"];
  nameEn: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
};

export type FieldGroupList = {
  __typename?: "FieldGroupList";
  count: Scalars["Int"]["output"];
  records: Array<FieldGroup>;
  total: Scalars["Int"]["output"];
};

export type FieldList = {
  __typename?: "FieldList";
  count: Scalars["Int"]["output"];
  records: Array<Field>;
  total: Scalars["Int"]["output"];
};

export type FieldValue = {
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type FieldValueBoolean = FieldValue & {
  __typename?: "FieldValueBoolean";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FieldValueDatetime = FieldValue & {
  __typename?: "FieldValueDatetime";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
};

export type FieldValueEnum = FieldValue & {
  __typename?: "FieldValueEnum";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  fieldEnumOptionId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export type FieldValueInput = {
  booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  datetimeValue?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
  enumValue?: InputMaybe<Scalars["String"]["input"]>;
  fieldId: Scalars["ID"]["input"];
  numberValue?: InputMaybe<Scalars["Float"]["input"]>;
  textValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type FieldValueNumber = FieldValue & {
  __typename?: "FieldValueNumber";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type FieldValueText = FieldValue & {
  __typename?: "FieldValueText";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum FieldValueTypeEnum {
  Boolean = "boolean",
  Datetime = "datetime",
  Enum = "enum",
  Number = "number",
  Text = "text",
}

export type File = {
  __typename?: "File";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  fileName: Scalars["String"]["output"];
  fileSize: Scalars["Int"]["output"];
  fileType: Scalars["String"]["output"];
  headSignedUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isImage: Scalars["Boolean"]["output"];
  isPdf: Scalars["Boolean"]["output"];
  largeUrl: Scalars["String"]["output"];
  thumbUrl: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type FindTenancyAdministration = CaseInterface & {
  __typename?: "FindTenancyAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowRentInfo: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  depositAmount?: Maybe<Scalars["Int"]["output"]>;
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  intervalAmount?: Maybe<Scalars["Int"]["output"]>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  moveInDate?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type FindTenancyAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FindTenancyAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Follower = {
  __typename?: "Follower";
  id: Scalars["ID"]["output"];
  user: CaseUser;
};

export type Inspection = {
  __typename?: "Inspection";
  answers: Array<InspectionAnswer>;
  canProcess: Scalars["Boolean"]["output"];
  cleaning?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  document?: Maybe<Document>;
  keys: Array<InspectionKey>;
  landlordSignature?: Maybe<Scalars["String"]["output"]>;
  landlordSignedBy?: Maybe<Scalars["String"]["output"]>;
  mayProcess: Scalars["Boolean"]["output"];
  meters: Array<InspectionMeter>;
  other?: Maybe<Scalars["String"]["output"]>;
  tenantSignature?: Maybe<Scalars["String"]["output"]>;
  tenantSignedBy?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type InspectionAnswer = {
  __typename?: "InspectionAnswer";
  area: InspectionArea;
  note?: Maybe<Scalars["String"]["output"]>;
  position: Scalars["Int"]["output"];
  rating?: Maybe<Scalars["Int"]["output"]>;
  subject: InspectionSubject;
};

export type InspectionArea = {
  __typename?: "InspectionArea";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InspectionKey = {
  __typename?: "InspectionKey";
  count: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  id?: Maybe<Scalars["ID"]["output"]>;
  keyMissing?: Maybe<Scalars["Int"]["output"]>;
  total: Scalars["Int"]["output"];
};

export type InspectionMeter = {
  __typename?: "InspectionMeter";
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  value: Scalars["Float"]["output"];
};

export type InspectionSubject = {
  __typename?: "InspectionSubject";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InterestListEntry = RecordInterface & {
  __typename?: "InterestListEntry";
  channel?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  deletedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  deletedBy?: Maybe<User>;
  deletedReason?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  notes: Array<InterestListNote>;
  phone: Scalars["String"]["output"];
  properties: Array<Property>;
  seenAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

/** Autogenerated return type of InterestListEntryCreateMutation. */
export type InterestListEntryCreateMutationPayload = {
  __typename?: "InterestListEntryCreateMutationPayload";
  duplicatePersonName?: Maybe<Scalars["String"]["output"]>;
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  personCreated?: Maybe<Scalars["Boolean"]["output"]>;
  result?: Maybe<InterestListEntry>;
};

/** Autogenerated return type of InterestListEntryDeleteMutation. */
export type InterestListEntryDeleteMutationPayload = {
  __typename?: "InterestListEntryDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListEntry>;
};

export type InterestListEntryList = {
  __typename?: "InterestListEntryList";
  count: Scalars["Int"]["output"];
  records: Array<InterestListEntry>;
  total: Scalars["Int"]["output"];
};

export enum InterestListEntryOrderByEnum {
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
}

/** Autogenerated return type of InterestListEntryUpdateMutation. */
export type InterestListEntryUpdateMutationPayload = {
  __typename?: "InterestListEntryUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListEntry>;
};

export type InterestListEntryWhereInput = {
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type InterestListNote = {
  __typename?: "InterestListNote";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  note: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  user: User;
};

/** Autogenerated return type of InterestListNoteCreateMutation. */
export type InterestListNoteCreateMutationPayload = {
  __typename?: "InterestListNoteCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListNote>;
};

export type InterestListPerson = RecordInterface & {
  __typename?: "InterestListPerson";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  email: Scalars["String"]["output"];
  entries: Array<InterestListEntry>;
  hasNewEntries: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isBlacklisted: Scalars["Boolean"]["output"];
  isProcessed: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  notes: Array<InterestListNote>;
  phone: Scalars["String"]["output"];
  properties: Array<Property>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

/** Autogenerated return type of InterestListPersonDeleteMutation. */
export type InterestListPersonDeleteMutationPayload = {
  __typename?: "InterestListPersonDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListPerson>;
};

export type InterestListPersonList = {
  __typename?: "InterestListPersonList";
  count: Scalars["Int"]["output"];
  records: Array<InterestListPerson>;
  total: Scalars["Int"]["output"];
};

export enum InterestListPersonOrderByEnum {
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
}

export enum InterestListPersonStatusEnum {
  All = "all",
  Blacklisted = "blacklisted",
  HasNew = "has_new",
  Processed = "processed",
}

/** Autogenerated return type of InterestListPersonUpdateMutation. */
export type InterestListPersonUpdateMutationPayload = {
  __typename?: "InterestListPersonUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListPerson>;
};

export type InterestListPersonWhereInput = {
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byStatus?: InputMaybe<Array<InterestListPersonStatusEnum>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type Message = RecordInterface & {
  __typename?: "Message";
  apartment?: Maybe<Scalars["String"]["output"]>;
  author: Scalars["String"]["output"];
  authorId: Scalars["String"]["output"];
  body: Scalars["String"]["output"];
  companies: Array<Company>;
  company?: Maybe<Company>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  emailsSentAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  property: Property;
  recipients: UserList;
  smsSentAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type MessageList = {
  __typename?: "MessageList";
  count: Scalars["Int"]["output"];
  records: Array<Message>;
  total: Scalars["Int"]["output"];
};

export enum MessageOrderByEnum {
  AuthorAsc = "author_ASC",
  AuthorDesc = "author_DESC",
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  ExpireAtAsc = "expireAt_ASC",
  ExpireAtDesc = "expireAt_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UpdatedAtAsc = "updatedAt_ASC",
  UpdatedAtDesc = "updatedAt_DESC",
}

export type MessageWhereInput = {
  byId?: InputMaybe<Scalars["ID"]["input"]>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MiscAdministration = CaseInterface & {
  __typename?: "MiscAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canStart: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayStart: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MiscAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MiscAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MiscService = CaseInterface & {
  __typename?: "MiscService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MiscServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MiscServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingInService = CaseInterface & {
  __typename?: "MovingInService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingInServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingInServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingInTenancy = CaseInterface & {
  __typename?: "MovingInTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingInTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingInTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingOutService = CaseInterface & {
  __typename?: "MovingOutService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingOutServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingOutServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingOutTenancy = CaseInterface & {
  __typename?: "MovingOutTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingOutTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingOutTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingSettlementAdministration = CaseInterface & {
  __typename?: "MovingSettlementAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canRequestTenantInformation: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canSendTenantInformation: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayRequestTenantInformation: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  nextTenancy?: Maybe<Tenancy>;
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantInformation?: Maybe<MovingSettlementTenantInformation>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingSettlementAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingSettlementAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingSettlementTenantInformation = {
  __typename?: "MovingSettlementTenantInformation";
  address?: Maybe<Scalars["String"]["output"]>;
  bankAccount?: Maybe<BankAccount>;
  city?: Maybe<Scalars["String"]["output"]>;
  countryName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  apartmentUpdate?: Maybe<ApartmentUpdateMutationPayload>;
  caseCommentRead?: Maybe<CaseCommentReadMutationPayload>;
  caseCreate?: Maybe<CaseCreateMutationPayload>;
  caseEndTenancyUpdateReasons?: Maybe<CaseEndTenancyUpdateReasonsMutationPayload>;
  caseInspectionProcess?: Maybe<CaseInspectionProcessMutationPayload>;
  caseInspectionSave?: Maybe<CaseInspectionSaveMutationPayload>;
  casePlanningUpdate?: Maybe<CasePlanningUpdateMutationPayload>;
  caseSchedule?: Maybe<CaseScheduleMutationPayload>;
  caseShareCreate?: Maybe<CaseShareCreateMutationPayload>;
  caseShareRevoke?: Maybe<CaseShareRevokeMutationPayload>;
  caseShareSend?: Maybe<CaseShareSendMutationPayload>;
  caseUpdate?: Maybe<CaseUpdateMutationPayload>;
  deleteInspectionAnswer?: Maybe<DeleteInspectionAnswerMutationPayload>;
  deletePayment?: Maybe<DeletePaymentMutationPayload>;
  deleteTextMacro?: Maybe<DeleteTextMacroMutationPayload>;
  economicResync?: Maybe<EconomicResyncMutationPayload>;
  interestListEntryCreate?: Maybe<InterestListEntryCreateMutationPayload>;
  interestListEntryDelete?: Maybe<InterestListEntryDeleteMutationPayload>;
  interestListEntryUpdate?: Maybe<InterestListEntryUpdateMutationPayload>;
  interestListNoteCreate?: Maybe<InterestListNoteCreateMutationPayload>;
  interestListPersonDelete?: Maybe<InterestListPersonDeleteMutationPayload>;
  interestListPersonUpdate?: Maybe<InterestListPersonUpdateMutationPayload>;
  lookupUser?: Maybe<User>;
  personalAccessTokenCreate?: Maybe<PersonalAccessTokenCreateMutationPayload>;
  personalAccessTokenDelete?: Maybe<PersonalAccessTokenDeleteMutationPayload>;
  phoneConfirm?: Maybe<PhoneConfirmMutationPayload>;
  propertyUpdate?: Maybe<PropertyUpdateMutationPayload>;
  saveInspectionAnswer?: Maybe<SaveInspectionAnswerMutationPayload>;
  savePayment?: Maybe<SavePaymentMutationPayload>;
  saveTextMacro?: Maybe<SaveTextMacroMutationPayload>;
  shortcutCreate?: Maybe<ShortcutCreateMutationPayload>;
  shortcutDelete?: Maybe<ShortcutDeleteMutationPayload>;
  shortcutUpdate?: Maybe<ShortcutUpdatePayload>;
  tenancyCreate?: Maybe<TenancyCreateMutationPayload>;
  tenancyDebtorLink?: Maybe<TenancyDebtorLinkMutationPayload>;
  tenancyDebtorUnlink?: Maybe<TenancyDebtorUnlinkMutationPayload>;
  tenancyEnd?: Maybe<EndTenancyMutationPayload>;
  tenancyNoteCreate?: Maybe<TenancyNoteCreateMutationPayload>;
  tenancyNoteDelete?: Maybe<TenancyNoteDeleteMutationPayload>;
  tenancyNoteUpdate?: Maybe<TenancyNoteUpdateMutationPayload>;
  tenancyRemove?: Maybe<TenancyRemoveMutationPayload>;
  tenancyResidentCreate?: Maybe<TenancyResidentCreateMutationPayload>;
  tenancyResidentRemove?: Maybe<TenancyResidentRemoveMutationPayload>;
  tenancyResidentUpdate?: Maybe<TenancyResidentUpdateMutationPayload>;
  tenancyRoleCreate?: Maybe<TenancyRoleCreateMutationPayload>;
  tenancyRoleRemove?: Maybe<TenancyRoleRemoveMutationPayload>;
  tenancyRoleUpdate?: Maybe<TenancyRoleUpdateMutationPayload>;
  tenancyUpdate?: Maybe<TenancyUpdateMutationPayload>;
  timelogDelete?: Maybe<TimelogDeleteMutationPayload>;
  timelogUpdate?: Maybe<TimelogUpdateMutationPayload>;
  toggleCaseFlag?: Maybe<ToggleCaseFlagMutationPayload>;
  updateExternalUser?: Maybe<UpdateExternalUserMutationPayload>;
};

export type MutationApartmentUpdateArgs = {
  apartmentId: Scalars["ID"]["input"];
  fields?: InputMaybe<Array<FieldValueInput>>;
};

export type MutationCaseCommentReadArgs = {
  caseId: Scalars["ID"]["input"];
  senderId: Scalars["ID"]["input"];
};

export type MutationCaseCreateArgs = {
  apartmentId?: InputMaybe<Scalars["ID"]["input"]>;
  input?: InputMaybe<CaseEventInput>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyId?: InputMaybe<Scalars["ID"]["input"]>;
  requester?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId?: InputMaybe<Scalars["ID"]["input"]>;
  type: CaseTypeEnum;
};

export type MutationCaseEndTenancyUpdateReasonsArgs = {
  caseId: Scalars["ID"]["input"];
  reasons: Array<EndTenancyReasonSelectionInput>;
};

export type MutationCaseInspectionProcessArgs = {
  input: BaseInspectionInput;
};

export type MutationCaseInspectionSaveArgs = {
  input: BaseInspectionInput;
};

export type MutationCasePlanningUpdateArgs = {
  caseId: Scalars["ID"]["input"];
  completeBefore?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  responsibleId?: InputMaybe<Scalars["ID"]["input"]>;
  scheduledDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledTime?: InputMaybe<Scalars["String"]["input"]>;
  startAfter?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

export type MutationCaseScheduleArgs = {
  caseId: Scalars["ID"]["input"];
  scheduledDate: Scalars["ISO8601Date"]["input"];
  scheduledTime: Scalars["String"]["input"];
};

export type MutationCaseShareCreateArgs = {
  caseId: Scalars["ID"]["input"];
  description: Scalars["String"]["input"];
  expiresAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
  note: Scalars["String"]["input"];
  selection: CaseShareSelectionInput;
};

export type MutationCaseShareRevokeArgs = {
  shareId: Scalars["ID"]["input"];
};

export type MutationCaseShareSendArgs = {
  emails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  phones?: InputMaybe<Array<Scalars["String"]["input"]>>;
  shareId: Scalars["ID"]["input"];
};

export type MutationCaseUpdateArgs = {
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
};

export type MutationDeleteInspectionAnswerArgs = {
  areaId: Scalars["ID"]["input"];
  caseId: Scalars["ID"]["input"];
  subjectId: Scalars["ID"]["input"];
};

export type MutationDeletePaymentArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteTextMacroArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationEconomicResyncArgs = {
  byTenancy?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationInterestListEntryCreateArgs = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  failOnDuplicate?: InputMaybe<Scalars["Boolean"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  propertyIds: Array<Scalars["ID"]["input"]>;
};

export type MutationInterestListEntryDeleteArgs = {
  id: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
};

export type MutationInterestListEntryUpdateArgs = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  propertyIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  seenAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
};

export type MutationInterestListNoteCreateArgs = {
  entryId: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
};

export type MutationInterestListPersonDeleteArgs = {
  id: Scalars["ID"]["input"];
  isBlacklisted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationInterestListPersonUpdateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  isBlacklisted?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationLookupUserArgs = {
  email: Scalars["String"]["input"];
};

export type MutationPersonalAccessTokenCreateArgs = {
  name: Scalars["String"]["input"];
};

export type MutationPersonalAccessTokenDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPhoneConfirmArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationPropertyUpdateArgs = {
  fields?: InputMaybe<Array<FieldValueInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  propertyId: Scalars["ID"]["input"];
};

export type MutationSaveInspectionAnswerArgs = {
  areaId: Scalars["ID"]["input"];
  caseId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  position: Scalars["Int"]["input"];
  rating: Scalars["Int"]["input"];
  subjectId: Scalars["ID"]["input"];
};

export type MutationSavePaymentArgs = {
  amount: Scalars["Float"]["input"];
  endDate: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["String"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationSaveTextMacroArgs = {
  available: Scalars["String"]["input"];
  content: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationShortcutCreateArgs = {
  attributes: ShortcutAttributesInput;
};

export type MutationShortcutDeleteArgs = {
  shortcutId: Scalars["ID"]["input"];
};

export type MutationShortcutUpdateArgs = {
  attributes: ShortcutAttributesInput;
  shortcutId: Scalars["ID"]["input"];
};

export type MutationTenancyCreateArgs = {
  apartment: Scalars["String"]["input"];
  depositAmount?: InputMaybe<Scalars["Float"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  user: TenancyUserInput;
};

export type MutationTenancyDebtorLinkArgs = {
  debtorId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyDebtorUnlinkArgs = {
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyEndArgs = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  endDate: Scalars["ISO8601Date"]["input"];
  endTenancyReasons?: InputMaybe<Array<Scalars["String"]["input"]>>;
  otherReasonNote?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyNoteCreateArgs = {
  attachments?: InputMaybe<Array<Scalars["String"]["input"]>>;
  content: Scalars["String"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyNoteDeleteArgs = {
  noteId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyNoteUpdateArgs = {
  attachments?: InputMaybe<Array<Scalars["String"]["input"]>>;
  attachmentsToRemove?: InputMaybe<Array<Scalars["String"]["input"]>>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyRemoveArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTenancyResidentCreateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyResidentRemoveArgs = {
  residentId: Scalars["ID"]["input"];
};

export type MutationTenancyResidentUpdateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  residentId: Scalars["ID"]["input"];
};

export type MutationTenancyRoleCreateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationTenancyRoleRemoveArgs = {
  tenancyRoleId: Scalars["ID"]["input"];
};

export type MutationTenancyRoleUpdateArgs = {
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenancyRoleId: Scalars["ID"]["input"];
};

export type MutationTenancyUpdateArgs = {
  depositAmount?: InputMaybe<Scalars["Float"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  fields?: InputMaybe<Array<FieldValueInput>>;
  intervalAmount?: InputMaybe<Scalars["Float"]["input"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTimelogDeleteArgs = {
  timelogId: Scalars["ID"]["input"];
};

export type MutationTimelogUpdateArgs = {
  accountId: Scalars["ID"]["input"];
  categoryId: Scalars["ID"]["input"];
  date: Scalars["ISO8601Date"]["input"];
  hoursWithoutMinutes: Scalars["Int"]["input"];
  minutesWithoutHours: Scalars["Int"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  timelogId: Scalars["ID"]["input"];
};

export type MutationToggleCaseFlagArgs = {
  caseId: Scalars["ID"]["input"];
  flagged?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateExternalUserArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerProduct = {
  __typename?: "PartnerProduct";
  name: Scalars["String"]["output"];
  partner: Scalars["String"]["output"];
};

export type Payment = {
  __typename?: "Payment";
  amount: Scalars["Float"]["output"];
  endDate: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  reference?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["String"]["output"];
};

export type PersonalAccessToken = {
  __typename?: "PersonalAccessToken";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  expiresAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  token?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for PersonalAccessToken. */
export type PersonalAccessTokenConnection = {
  __typename?: "PersonalAccessTokenConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PersonalAccessTokenEdge>>>;
  /** A list of nodes. */
  nodes: Array<PersonalAccessToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Autogenerated return type of PersonalAccessTokenCreateMutation. */
export type PersonalAccessTokenCreateMutationPayload = {
  __typename?: "PersonalAccessTokenCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  personalAccessToken?: Maybe<PersonalAccessToken>;
};

/** Autogenerated return type of PersonalAccessTokenDeleteMutation. */
export type PersonalAccessTokenDeleteMutationPayload = {
  __typename?: "PersonalAccessTokenDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

/** An edge in a connection. */
export type PersonalAccessTokenEdge = {
  __typename?: "PersonalAccessTokenEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<PersonalAccessToken>;
};

/** Autogenerated return type of PhoneConfirmMutation. */
export type PhoneConfirmMutationPayload = {
  __typename?: "PhoneConfirmMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  user?: Maybe<User>;
};

export type PreparationService = CaseInterface & {
  __typename?: "PreparationService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type PreparationServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PreparationServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Property = RecordInterface & {
  __typename?: "Property";
  activeServiceCasesCount: Scalars["Int"]["output"];
  administrator: Company;
  availableFieldGroups: Array<FieldGroup>;
  canUpdate: Scalars["Boolean"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  fieldGroups: Array<PropertyFieldGroup>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  owner: Company;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type PropertyFieldGroup = {
  __typename?: "PropertyFieldGroup";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  values: Array<FieldValue>;
};

export type PropertyList = {
  __typename?: "PropertyList";
  count: Scalars["Int"]["output"];
  records: Array<Property>;
  total: Scalars["Int"]["output"];
};

export enum PropertyOrderByEnum {
  AdministratorAsc = "administrator_ASC",
  AdministratorDesc = "administrator_DESC",
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  OwnerAsc = "owner_ASC",
  OwnerDesc = "owner_DESC",
  UpdatedAtAsc = "updatedAt_ASC",
  UpdatedAtDesc = "updatedAt_DESC",
}

/** Autogenerated return type of PropertyUpdateMutation. */
export type PropertyUpdateMutationPayload = {
  __typename?: "PropertyUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  property?: Maybe<Property>;
};

export type PropertyWhereInput = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAdministrator?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byOwner?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byServiceTeam?: InputMaybe<Scalars["ID"]["input"]>;
  forCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  interestListEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
  __typename?: "Query";
  apartment?: Maybe<Apartment>;
  apartments: ApartmentList;
  attachmentCategories: Array<AttachmentCategory>;
  case?: Maybe<CaseInterface>;
  caseDefinitions: Array<CaseDefinition>;
  cases: CaseList;
  companies: CompanyList;
  contractOptions: ContractOptions;
  currentUser?: Maybe<User>;
  economicDebtors: EconomicDebtorList;
  economicSubscribers: EconomicSubscriberList;
  economicSubscription?: Maybe<EconomicSubscription>;
  economicSubscriptions: EconomicSubscriptionList;
  endTenancyReasons: Array<EndTenancyReason>;
  fieldGroups: FieldGroupList;
  fields?: Maybe<FieldList>;
  interestListEntries: InterestListEntryList;
  interestListEntry?: Maybe<InterestListEntry>;
  interestListPeople: InterestListPersonList;
  interestListPerson?: Maybe<InterestListPerson>;
  properties: PropertyList;
  property?: Maybe<Property>;
  questions: Array<Question>;
  team?: Maybe<Team>;
  teamMembers: UserList;
  teams: TeamList;
  tenancies: TenancyList;
  tenancy?: Maybe<Tenancy>;
  textMacros: Array<TextMacro>;
  timelogAccounts: Array<TimelogAccount>;
};

export type QueryApartmentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryApartmentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ApartmentOrderByEnum>;
  where?: InputMaybe<ApartmentWhereInput>;
};

export type QueryAttachmentCategoriesArgs = {
  lang: Scalars["String"]["input"];
};

export type QueryCaseArgs = {
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  caseId: Scalars["ID"]["input"];
};

export type QueryCasesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type QueryCompaniesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CompanyOrderByEnum>;
  where?: InputMaybe<CompanyWhereInput>;
};

export type QueryEconomicDebtorsArgs = {
  where?: InputMaybe<EconomicDebtorWhereInput>;
};

export type QueryEconomicSubscribersArgs = {
  where?: InputMaybe<EconomicSubscriberWhereInput>;
};

export type QueryEconomicSubscriptionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryEconomicSubscriptionsArgs = {
  where?: InputMaybe<EconomicSubscriptionWhereInput>;
};

export type QueryInterestListEntriesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InterestListEntryOrderByEnum>;
  where?: InputMaybe<InterestListEntryWhereInput>;
};

export type QueryInterestListEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInterestListPeopleArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InterestListPersonOrderByEnum>;
  where?: InputMaybe<InterestListPersonWhereInput>;
};

export type QueryInterestListPersonArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPropertiesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<PropertyOrderByEnum>;
  where?: InputMaybe<PropertyWhereInput>;
};

export type QueryPropertyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryQuestionsArgs = {
  where?: InputMaybe<QuestionWhereInput>;
};

export type QueryTeamArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTeamMembersArgs = {
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type QueryTeamsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<TeamOrderByEnum>;
  scope?: InputMaybe<TeamScopeEnum>;
};

export type QueryTenanciesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<TenancyOrderByEnum>;
  where?: InputMaybe<TenancyWhereInput>;
};

export type QueryTenancyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTextMacrosArgs = {
  available: Array<Scalars["String"]["input"]>;
};

export type Question = {
  __typename?: "Question";
  answerDa: Scalars["String"]["output"];
  answerEn: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  properties?: Maybe<Array<QuestionProperty>>;
  questionDa: Scalars["String"]["output"];
  questionEn: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type QuestionProperty = {
  __typename?: "QuestionProperty";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type QuestionWhereInput = {
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RecordInterface = {
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type RequestTenancy = CaseInterface & {
  __typename?: "RequestTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canCreateTenancy: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  comment?: Maybe<Scalars["String"]["output"]>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createTenancyCases: Array<CreateTenancy>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  daysBetween?: Maybe<Scalars["String"]["output"]>;
  displayName: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  numberOfResidents: Scalars["Int"]["output"];
  parent?: Maybe<CaseInterface>;
  partnerProduct?: Maybe<PartnerProduct>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  residents: Array<Resident>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["ISO8601Date"]["output"];
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type RequestTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RequestTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Resident = {
  __typename?: "Resident";
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
};

/** Autogenerated return type of SaveInspectionAnswerMutation. */
export type SaveInspectionAnswerMutationPayload = {
  __typename?: "SaveInspectionAnswerMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InspectionAnswer>;
};

/** Autogenerated return type of SavePaymentMutation. */
export type SavePaymentMutationPayload = {
  __typename?: "SavePaymentMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of SaveTextMacroMutation. */
export type SaveTextMacroMutationPayload = {
  __typename?: "SaveTextMacroMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  textMacro?: Maybe<TextMacro>;
};

export type ServiceTeam = Team & {
  __typename?: "ServiceTeam";
  id: Scalars["ID"]["output"];
  members: Array<User>;
  name: Scalars["String"]["output"];
  properties: ServiceTeamPropertyConnection;
};

export type ServiceTeamPropertiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<PropertyOrderByEnum>;
};

export type ServiceTeamProperty = {
  __typename?: "ServiceTeamProperty";
  id: Scalars["ID"]["output"];
  isServiceResponsible: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
};

/** The connection type for ServiceTeamProperty. */
export type ServiceTeamPropertyConnection = {
  __typename?: "ServiceTeamPropertyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ServiceTeamPropertyEdge>>>;
  /** A list of nodes. */
  nodes: Array<ServiceTeamProperty>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a connection. */
export type ServiceTeamPropertyEdge = {
  __typename?: "ServiceTeamPropertyEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<ServiceTeamProperty>;
};

export type Shortcut = {
  __typename?: "Shortcut";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  state: Scalars["JSON"]["output"];
  type: Scalars["String"]["output"];
};

export type ShortcutAttributesInput = {
  name: Scalars["String"]["input"];
  state: Scalars["JSON"]["input"];
  type: Scalars["String"]["input"];
};

/** The connection type for Shortcut. */
export type ShortcutConnection = {
  __typename?: "ShortcutConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShortcutEdge>>>;
  /** A list of nodes. */
  nodes: Array<Shortcut>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Autogenerated return type of ShortcutCreateMutation. */
export type ShortcutCreateMutationPayload = {
  __typename?: "ShortcutCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  shortcut?: Maybe<Shortcut>;
};

/** Autogenerated return type of ShortcutDeleteMutation. */
export type ShortcutDeleteMutationPayload = {
  __typename?: "ShortcutDeleteMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  shortcutId?: Maybe<Scalars["ID"]["output"]>;
};

/** An edge in a connection. */
export type ShortcutEdge = {
  __typename?: "ShortcutEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Shortcut>;
};

/** Autogenerated return type of ShortcutUpdate. */
export type ShortcutUpdatePayload = {
  __typename?: "ShortcutUpdatePayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  shortcut?: Maybe<Shortcut>;
};

export type ShortcutWhereInput = {
  query?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type Team = {
  id: Scalars["ID"]["output"];
  members: Array<User>;
  name: Scalars["String"]["output"];
};

export type TeamList = {
  __typename?: "TeamList";
  count: Scalars["Int"]["output"];
  records: Array<Team>;
  total: Scalars["Int"]["output"];
};

export type TeamMemberWhereInput = {
  caseWorkers?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export enum TeamOrderByEnum {
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
}

export enum TeamScopeEnum {
  /** Administration teams */
  Administration = "ADMINISTRATION",
  /** Service teams */
  Service = "SERVICE",
}

export type Tenancy = RecordInterface & {
  __typename?: "Tenancy";
  apartment: Apartment;
  availableFieldGroups: Array<FieldGroup>;
  canUpdate: Scalars["Boolean"]["output"];
  cases: CaseList;
  contractCase?: Maybe<CreateTenancy>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  depositAmount?: Maybe<Scalars["Int"]["output"]>;
  depositDueDate?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  documents?: Maybe<Array<Document>>;
  economic: TenancyEconomic;
  electricityAmount?: Maybe<Scalars["Int"]["output"]>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  endTenancyTerms?: Maybe<TenancyTerms>;
  endTenancyTermsCondition?: Maybe<Scalars["String"]["output"]>;
  expectedMovingInCases: Array<CaseDefinition>;
  expectedMovingOutCases: Array<CaseDefinition>;
  fieldGroups: Array<TenancyFieldGroup>;
  hasEndTenancyCase: Scalars["Boolean"]["output"];
  heatingAmount?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  intervalAmount?: Maybe<Scalars["Int"]["output"]>;
  intervalAmountType: TenancyIntervalAmountTypeEnum;
  keys: Array<TenancyKey>;
  lastPaymentDate?: Maybe<Scalars["String"]["output"]>;
  movingInCase?: Maybe<Case>;
  movingOutCase?: Maybe<Case>;
  notes: TenancyNoteList;
  paymentAttention: TenancyPaymentAttentionEnum;
  payments: Array<Payment>;
  removable: Scalars["Boolean"]["output"];
  requestedEndDate?: Maybe<Scalars["String"]["output"]>;
  residents: Array<Resident>;
  roles: Array<TenancyRole>;
  startDate: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  user: User;
  waterAmount?: Maybe<Scalars["Int"]["output"]>;
};

export type TenancyCasesArgs = {
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type TenancyEndTenancyTermsArgs = {
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

/** Autogenerated return type of TenancyCreateMutation. */
export type TenancyCreateMutationPayload = {
  __typename?: "TenancyCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancy?: Maybe<Tenancy>;
};

/** Autogenerated return type of TenancyDebtorLinkMutation. */
export type TenancyDebtorLinkMutationPayload = {
  __typename?: "TenancyDebtorLinkMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  isLinked?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Autogenerated return type of TenancyDebtorUnlinkMutation. */
export type TenancyDebtorUnlinkMutationPayload = {
  __typename?: "TenancyDebtorUnlinkMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  isUnlinked: Scalars["Boolean"]["output"];
};

export type TenancyEconomic = {
  __typename?: "TenancyEconomic";
  advanceElectricityAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceElectricityIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceElectricityIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceElectricitySignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceHeatingAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceHeatingIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceHeatingIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceHeatingSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWasteWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceWasteWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWasteWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWasteWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  commercialRentAmount?: Maybe<Scalars["Float"]["output"]>;
  commercialRentIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  commercialRentIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  commercialRentSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  companySyncedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  debtor?: Maybe<EconomicDebtor>;
  deposit?: Maybe<Scalars["Float"]["output"]>;
  otherAmount?: Maybe<Scalars["Float"]["output"]>;
  otherIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  otherIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  otherSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  parkingAmount?: Maybe<Scalars["Float"]["output"]>;
  parkingIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  parkingIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  parkingSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  prepaidRent?: Maybe<Scalars["Float"]["output"]>;
  regulationDepositAmount?: Maybe<Scalars["Float"]["output"]>;
  regulationDepositIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationDepositIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationDepositSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationPrepaidRentAmount?: Maybe<Scalars["Float"]["output"]>;
  regulationPrepaidRentIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationPrepaidRentIntervalStartAt?: Maybe<
    Scalars["ISO8601Date"]["output"]
  >;
  regulationPrepaidRentSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentAmount?: Maybe<Scalars["Float"]["output"]>;
  rentIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentReductionAmount?: Maybe<Scalars["Float"]["output"]>;
  rentReductionIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentReductionIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentReductionSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementElectricityAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementElectricityIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementElectricityIntervalStartAt?: Maybe<
    Scalars["ISO8601Date"]["output"]
  >;
  settlementElectricitySignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementHeatingAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementHeatingIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementHeatingIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementHeatingSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWasteWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementWasteWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWasteWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWasteWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  subscription?: Maybe<TenancyEconomicSubscription>;
  subscriptions?: Maybe<Array<TenancyEconomicSubscription>>;
};

export type TenancyEconomicSubscriptionArgs = {
  id: Scalars["ID"]["input"];
};

export type TenancyEconomicSubscription = {
  __typename?: "TenancyEconomicSubscription";
  currentAmount?: Maybe<Scalars["Float"]["output"]>;
  history?: Maybe<Array<EconomicSubscriber>>;
  id: Scalars["ID"]["output"];
  interval?: Maybe<EconomicSubscriptionIntervalEnum>;
  name: Scalars["String"]["output"];
};

export type TenancyFieldGroup = {
  __typename?: "TenancyFieldGroup";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  values: Array<FieldValue>;
};

export enum TenancyIntervalAmountTypeEnum {
  Contract = "contract",
  Economic = "economic",
  Unknown = "unknown",
}

export type TenancyKey = {
  __typename?: "TenancyKey";
  description: Scalars["String"]["output"];
  handedIn?: Maybe<Scalars["Int"]["output"]>;
  handedOut: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  missing: Scalars["Int"]["output"];
};

export type TenancyList = {
  __typename?: "TenancyList";
  count: Scalars["Int"]["output"];
  records: Array<Tenancy>;
  total: Scalars["Int"]["output"];
};

export type TenancyNote = {
  __typename?: "TenancyNote";
  attachments: Array<File>;
  content: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  user: User;
};

/** Autogenerated return type of TenancyNoteCreateMutation. */
export type TenancyNoteCreateMutationPayload = {
  __typename?: "TenancyNoteCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancyNote?: Maybe<TenancyNote>;
};

/** Autogenerated return type of TenancyNoteDeleteMutation. */
export type TenancyNoteDeleteMutationPayload = {
  __typename?: "TenancyNoteDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancyNote?: Maybe<TenancyNote>;
};

export type TenancyNoteList = {
  __typename?: "TenancyNoteList";
  count: Scalars["Int"]["output"];
  records: Array<TenancyNote>;
  total: Scalars["Int"]["output"];
};

/** Autogenerated return type of TenancyNoteUpdateMutation. */
export type TenancyNoteUpdateMutationPayload = {
  __typename?: "TenancyNoteUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancyNote?: Maybe<TenancyNote>;
};

export enum TenancyOrderByEnum {
  ApartmentPublicIdAsc = "apartmentPublicId_ASC",
  ApartmentPublicIdDesc = "apartmentPublicId_DESC",
  ApartmentAsc = "apartment_ASC",
  ApartmentDesc = "apartment_DESC",
  CprAsc = "cpr_ASC",
  CprDesc = "cpr_DESC",
  DepositAmountAsc = "depositAmount_ASC",
  DepositAmountDesc = "depositAmount_DESC",
  DepositDueDateAsc = "depositDueDate_ASC",
  DepositDueDateDesc = "depositDueDate_DESC",
  DepositAsc = "deposit_ASC",
  DepositDesc = "deposit_DESC",
  EconomicAdvanceElectricityAmountAsc = "economicAdvanceElectricityAmount_ASC",
  EconomicAdvanceElectricityAmountDesc = "economicAdvanceElectricityAmount_DESC",
  EconomicAdvanceElectricityIntervalEndAtAsc = "economicAdvanceElectricityIntervalEndAt_ASC",
  EconomicAdvanceElectricityIntervalEndAtDesc = "economicAdvanceElectricityIntervalEndAt_DESC",
  EconomicAdvanceElectricityIntervalStartAtAsc = "economicAdvanceElectricityIntervalStartAt_ASC",
  EconomicAdvanceElectricityIntervalStartAtDesc = "economicAdvanceElectricityIntervalStartAt_DESC",
  EconomicAdvanceHeatingAmountAsc = "economicAdvanceHeatingAmount_ASC",
  EconomicAdvanceHeatingAmountDesc = "economicAdvanceHeatingAmount_DESC",
  EconomicAdvanceHeatingIntervalEndAtAsc = "economicAdvanceHeatingIntervalEndAt_ASC",
  EconomicAdvanceHeatingIntervalEndAtDesc = "economicAdvanceHeatingIntervalEndAt_DESC",
  EconomicAdvanceHeatingIntervalStartAtAsc = "economicAdvanceHeatingIntervalStartAt_ASC",
  EconomicAdvanceHeatingIntervalStartAtDesc = "economicAdvanceHeatingIntervalStartAt_DESC",
  EconomicAdvanceWasteWaterAmountAsc = "economicAdvanceWasteWaterAmount_ASC",
  EconomicAdvanceWasteWaterAmountDesc = "economicAdvanceWasteWaterAmount_DESC",
  EconomicAdvanceWasteWaterIntervalEndAtAsc = "economicAdvanceWasteWaterIntervalEndAt_ASC",
  EconomicAdvanceWasteWaterIntervalEndAtDesc = "economicAdvanceWasteWaterIntervalEndAt_DESC",
  EconomicAdvanceWasteWaterIntervalStartAtAsc = "economicAdvanceWasteWaterIntervalStartAt_ASC",
  EconomicAdvanceWasteWaterIntervalStartAtDesc = "economicAdvanceWasteWaterIntervalStartAt_DESC",
  EconomicAdvanceWaterAmountAsc = "economicAdvanceWaterAmount_ASC",
  EconomicAdvanceWaterAmountDesc = "economicAdvanceWaterAmount_DESC",
  EconomicAdvanceWaterIntervalEndAtAsc = "economicAdvanceWaterIntervalEndAt_ASC",
  EconomicAdvanceWaterIntervalEndAtDesc = "economicAdvanceWaterIntervalEndAt_DESC",
  EconomicAdvanceWaterIntervalStartAtAsc = "economicAdvanceWaterIntervalStartAt_ASC",
  EconomicAdvanceWaterIntervalStartAtDesc = "economicAdvanceWaterIntervalStartAt_DESC",
  EconomicCommercialRentAmountAsc = "economicCommercialRentAmount_ASC",
  EconomicCommercialRentAmountDesc = "economicCommercialRentAmount_DESC",
  EconomicCommercialRentIntervalEndAtAsc = "economicCommercialRentIntervalEndAt_ASC",
  EconomicCommercialRentIntervalEndAtDesc = "economicCommercialRentIntervalEndAt_DESC",
  EconomicCommercialRentIntervalStartAtAsc = "economicCommercialRentIntervalStartAt_ASC",
  EconomicCommercialRentIntervalStartAtDesc = "economicCommercialRentIntervalStartAt_DESC",
  EconomicOtherAmountAsc = "economicOtherAmount_ASC",
  EconomicOtherAmountDesc = "economicOtherAmount_DESC",
  EconomicOtherIntervalEndAtAsc = "economicOtherIntervalEndAt_ASC",
  EconomicOtherIntervalEndAtDesc = "economicOtherIntervalEndAt_DESC",
  EconomicOtherIntervalStartAtAsc = "economicOtherIntervalStartAt_ASC",
  EconomicOtherIntervalStartAtDesc = "economicOtherIntervalStartAt_DESC",
  EconomicParkingAmountAsc = "economicParkingAmount_ASC",
  EconomicParkingAmountDesc = "economicParkingAmount_DESC",
  EconomicParkingIntervalEndAtAsc = "economicParkingIntervalEndAt_ASC",
  EconomicParkingIntervalEndAtDesc = "economicParkingIntervalEndAt_DESC",
  EconomicParkingIntervalStartAtAsc = "economicParkingIntervalStartAt_ASC",
  EconomicParkingIntervalStartAtDesc = "economicParkingIntervalStartAt_DESC",
  EconomicRegulationDepositAmountAsc = "economicRegulationDepositAmount_ASC",
  EconomicRegulationDepositAmountDesc = "economicRegulationDepositAmount_DESC",
  EconomicRegulationDepositIntervalEndAtAsc = "economicRegulationDepositIntervalEndAt_ASC",
  EconomicRegulationDepositIntervalEndAtDesc = "economicRegulationDepositIntervalEndAt_DESC",
  EconomicRegulationDepositIntervalStartAtAsc = "economicRegulationDepositIntervalStartAt_ASC",
  EconomicRegulationDepositIntervalStartAtDesc = "economicRegulationDepositIntervalStartAt_DESC",
  EconomicRegulationPrepaidRentAmountAsc = "economicRegulationPrepaidRentAmount_ASC",
  EconomicRegulationPrepaidRentAmountDesc = "economicRegulationPrepaidRentAmount_DESC",
  EconomicRegulationPrepaidRentIntervalEndAtAsc = "economicRegulationPrepaidRentIntervalEndAt_ASC",
  EconomicRegulationPrepaidRentIntervalEndAtDesc = "economicRegulationPrepaidRentIntervalEndAt_DESC",
  EconomicRegulationPrepaidRentIntervalStartAtAsc = "economicRegulationPrepaidRentIntervalStartAt_ASC",
  EconomicRegulationPrepaidRentIntervalStartAtDesc = "economicRegulationPrepaidRentIntervalStartAt_DESC",
  EconomicRentAmountAsc = "economicRentAmount_ASC",
  EconomicRentAmountDesc = "economicRentAmount_DESC",
  EconomicRentIntervalEndAtAsc = "economicRentIntervalEndAt_ASC",
  EconomicRentIntervalEndAtDesc = "economicRentIntervalEndAt_DESC",
  EconomicRentIntervalStartAtAsc = "economicRentIntervalStartAt_ASC",
  EconomicRentIntervalStartAtDesc = "economicRentIntervalStartAt_DESC",
  EconomicRentReductionAmountAsc = "economicRentReductionAmount_ASC",
  EconomicRentReductionAmountDesc = "economicRentReductionAmount_DESC",
  EconomicRentReductionIntervalEndAtAsc = "economicRentReductionIntervalEndAt_ASC",
  EconomicRentReductionIntervalEndAtDesc = "economicRentReductionIntervalEndAt_DESC",
  EconomicRentReductionIntervalStartAtAsc = "economicRentReductionIntervalStartAt_ASC",
  EconomicRentReductionIntervalStartAtDesc = "economicRentReductionIntervalStartAt_DESC",
  EconomicSettlementElectricityAmountAsc = "economicSettlementElectricityAmount_ASC",
  EconomicSettlementElectricityAmountDesc = "economicSettlementElectricityAmount_DESC",
  EconomicSettlementElectricityIntervalEndAtAsc = "economicSettlementElectricityIntervalEndAt_ASC",
  EconomicSettlementElectricityIntervalEndAtDesc = "economicSettlementElectricityIntervalEndAt_DESC",
  EconomicSettlementElectricityIntervalStartAtAsc = "economicSettlementElectricityIntervalStartAt_ASC",
  EconomicSettlementElectricityIntervalStartAtDesc = "economicSettlementElectricityIntervalStartAt_DESC",
  EconomicSettlementHeatingAmountAsc = "economicSettlementHeatingAmount_ASC",
  EconomicSettlementHeatingAmountDesc = "economicSettlementHeatingAmount_DESC",
  EconomicSettlementHeatingIntervalEndAtAsc = "economicSettlementHeatingIntervalEndAt_ASC",
  EconomicSettlementHeatingIntervalEndAtDesc = "economicSettlementHeatingIntervalEndAt_DESC",
  EconomicSettlementHeatingIntervalStartAtAsc = "economicSettlementHeatingIntervalStartAt_ASC",
  EconomicSettlementHeatingIntervalStartAtDesc = "economicSettlementHeatingIntervalStartAt_DESC",
  EconomicSettlementWasteWaterAmountAsc = "economicSettlementWasteWaterAmount_ASC",
  EconomicSettlementWasteWaterAmountDesc = "economicSettlementWasteWaterAmount_DESC",
  EconomicSettlementWasteWaterIntervalEndAtAsc = "economicSettlementWasteWaterIntervalEndAt_ASC",
  EconomicSettlementWasteWaterIntervalEndAtDesc = "economicSettlementWasteWaterIntervalEndAt_DESC",
  EconomicSettlementWasteWaterIntervalStartAtAsc = "economicSettlementWasteWaterIntervalStartAt_ASC",
  EconomicSettlementWasteWaterIntervalStartAtDesc = "economicSettlementWasteWaterIntervalStartAt_DESC",
  EconomicSettlementWaterAmountAsc = "economicSettlementWaterAmount_ASC",
  EconomicSettlementWaterAmountDesc = "economicSettlementWaterAmount_DESC",
  EconomicSettlementWaterIntervalEndAtAsc = "economicSettlementWaterIntervalEndAt_ASC",
  EconomicSettlementWaterIntervalEndAtDesc = "economicSettlementWaterIntervalEndAt_DESC",
  EconomicSettlementWaterIntervalStartAtAsc = "economicSettlementWaterIntervalStartAt_ASC",
  EconomicSettlementWaterIntervalStartAtDesc = "economicSettlementWaterIntervalStartAt_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  EndDateAsc = "endDate_ASC",
  EndDateDesc = "endDate_DESC",
  IntervalAmountAsc = "intervalAmount_ASC",
  IntervalAmountDesc = "intervalAmount_DESC",
  LastPaymentDateAsc = "lastPaymentDate_ASC",
  LastPaymentDateDesc = "lastPaymentDate_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
  PrepaidRentAsc = "prepaidRent_ASC",
  PrepaidRentDesc = "prepaidRent_DESC",
  RequestedEndDateAsc = "requestedEndDate_ASC",
  RequestedEndDateDesc = "requestedEndDate_DESC",
  StartDateAsc = "startDate_ASC",
  StartDateDesc = "startDate_DESC",
}

export enum TenancyPaymentAttentionEnum {
  Critical = "critical",
  Normal = "normal",
  Success = "success",
}

/** Autogenerated return type of TenancyRemoveMutation. */
export type TenancyRemoveMutationPayload = {
  __typename?: "TenancyRemoveMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancy?: Maybe<Tenancy>;
};

/** Autogenerated return type of TenancyResidentCreateMutation. */
export type TenancyResidentCreateMutationPayload = {
  __typename?: "TenancyResidentCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  resident?: Maybe<Resident>;
};

/** Autogenerated return type of TenancyResidentRemoveMutation. */
export type TenancyResidentRemoveMutationPayload = {
  __typename?: "TenancyResidentRemoveMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  resident?: Maybe<Resident>;
};

/** Autogenerated return type of TenancyResidentUpdateMutation. */
export type TenancyResidentUpdateMutationPayload = {
  __typename?: "TenancyResidentUpdateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  resident?: Maybe<Resident>;
};

export type TenancyRole = {
  __typename?: "TenancyRole";
  id: Scalars["ID"]["output"];
  isPrimary: Scalars["Boolean"]["output"];
  isResident: Scalars["Boolean"]["output"];
  user: User;
};

/** Autogenerated return type of TenancyRoleCreateMutation. */
export type TenancyRoleCreateMutationPayload = {
  __typename?: "TenancyRoleCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancyRole?: Maybe<TenancyRole>;
};

/** Autogenerated return type of TenancyRoleRemoveMutation. */
export type TenancyRoleRemoveMutationPayload = {
  __typename?: "TenancyRoleRemoveMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancyRole?: Maybe<TenancyRole>;
};

/** Autogenerated return type of TenancyRoleUpdateMutation. */
export type TenancyRoleUpdateMutationPayload = {
  __typename?: "TenancyRoleUpdateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancyRole?: Maybe<TenancyRole>;
};

export type TenancyTerms = {
  __typename?: "TenancyTerms";
  earlyEndDate?: Maybe<Scalars["Boolean"]["output"]>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  endDateLongFormat?: Maybe<Scalars["String"]["output"]>;
  lastRentDate?: Maybe<Scalars["String"]["output"]>;
  lastRentDateLongFormat?: Maybe<Scalars["String"]["output"]>;
  leaveDate?: Maybe<Scalars["String"]["output"]>;
  leaveDateLongFormat?: Maybe<Scalars["String"]["output"]>;
};

/** Autogenerated return type of TenancyUpdateMutation. */
export type TenancyUpdateMutationPayload = {
  __typename?: "TenancyUpdateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancy?: Maybe<Tenancy>;
};

export type TenancyUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  external: Scalars["Boolean"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type TenancyWhereInput = {
  approved?: InputMaybe<Scalars["Boolean"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAdministrator?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byApartment?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byPaymentAttention?: InputMaybe<Array<TenancyPaymentAttentionEnum>>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  conflictingWithDateRange?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type TextMacro = {
  __typename?: "TextMacro";
  available: Scalars["String"]["output"];
  content: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type Timelog = {
  __typename?: "Timelog";
  account: TimelogAccount;
  canDestroy: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  category: TimelogCategory;
  date: Scalars["ISO8601Date"]["output"];
  hoursWithoutMinutes: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  minutesWithoutHours: Scalars["Int"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  user: User;
};

export type TimelogAccount = {
  __typename?: "TimelogAccount";
  categories: Array<TimelogCategory>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type TimelogCategory = {
  __typename?: "TimelogCategory";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

/** Autogenerated return type of TimelogDeleteMutation. */
export type TimelogDeleteMutationPayload = {
  __typename?: "TimelogDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<Timelog>;
};

/** Autogenerated return type of TimelogUpdateMutation. */
export type TimelogUpdateMutationPayload = {
  __typename?: "TimelogUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

/** Autogenerated return type of ToggleCaseFlagMutation. */
export type ToggleCaseFlagMutationPayload = {
  __typename?: "ToggleCaseFlagMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
};

/** Autogenerated return type of UpdateExternalUserMutation. */
export type UpdateExternalUserMutationPayload = {
  __typename?: "UpdateExternalUserMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  user?: Maybe<User>;
};

export type User = RecordInterface & {
  __typename?: "User";
  address?: Maybe<Scalars["String"]["output"]>;
  bankAccount?: Maybe<BankAccount>;
  business: Scalars["Boolean"]["output"];
  city?: Maybe<Scalars["String"]["output"]>;
  company?: Maybe<Scalars["String"]["output"]>;
  countryName?: Maybe<Scalars["String"]["output"]>;
  cpr?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isAdministrator: Scalars["Boolean"]["output"];
  isExternal: Scalars["Boolean"]["output"];
  isPhoneConfirmed: Scalars["Boolean"]["output"];
  isServiceAdministrator: Scalars["Boolean"]["output"];
  isServiceCaseWorker: Scalars["Boolean"]["output"];
  isSystemAdministrator: Scalars["Boolean"]["output"];
  locale: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  personalAccessTokens: PersonalAccessTokenConnection;
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  protected: Scalars["Boolean"]["output"];
  serviceTeams: Array<ServiceTeam>;
  shortcut?: Maybe<Shortcut>;
  shortcuts: ShortcutConnection;
  showSensitiveInfo: Scalars["Boolean"]["output"];
  teams: Array<AdministrationTeam>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  vat?: Maybe<Scalars["String"]["output"]>;
};

export type UserPersonalAccessTokensArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserServiceTeamsArgs = {
  orderBy?: InputMaybe<TeamOrderByEnum>;
};

export type UserShortcutArgs = {
  shortcutId: Scalars["ID"]["input"];
};

export type UserShortcutsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<ShortcutWhereInput>;
};

export type UserList = {
  __typename?: "UserList";
  count: Scalars["Int"]["output"];
  records: Array<User>;
  total: Scalars["Int"]["output"];
};

export type UtilityAdministration = CaseInterface & {
  __typename?: "UtilityAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type UtilityAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UtilityAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type AttachmentCover_RemoveAttachmentMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type AttachmentCover_RemoveAttachmentMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type CallToActionReceive_ReceiveMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
}>;

export type CallToActionReceive_ReceiveMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type CallToActionSchedule_ScheduleMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  date: Scalars["ISO8601Date"]["input"];
  time: Scalars["String"]["input"];
}>;

export type CallToActionSchedule_ScheduleMutation = {
  __typename?: "Mutation";
  caseSchedule?: {
    __typename?: "CaseScheduleMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type ServiceCaseCheckbox_ToggleCheckMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type ServiceCaseCheckbox_ToggleCheckMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type CaseComment_ReadCommentMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  senderId: Scalars["ID"]["input"];
}>;

export type CaseComment_ReadCommentMutation = {
  __typename?: "Mutation";
  caseCommentRead?: {
    __typename?: "CaseCommentReadMutationPayload";
    errors: Array<string>;
  } | null;
};

type ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment = {
  __typename?: "AdministrationTeam";
  id: string;
  name: string;
  members: Array<{ __typename?: "User"; id: string; name: string }>;
} & {
  " $fragmentName"?: "ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment";
};

type ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment = {
  __typename?: "ServiceTeam";
  id: string;
  name: string;
  members: Array<{ __typename?: "User"; id: string; name: string }>;
} & {
  " $fragmentName"?: "ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment";
};

export type ModalChangeResponsible_PossibleServiceTeamFragment =
  | ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment
  | ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;

export type ModalChangeResponsible_PossibleResponsibleQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type ModalChangeResponsible_PossibleResponsibleQuery = {
  __typename?: "Query";
  case?:
    | {
        __typename?: "CleaningService";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "CreateTenancy";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "EndTenancy";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "FindTenancyAdministration";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MiscAdministration";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MiscService";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MovingInService";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MovingInTenancy";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MovingOutService";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MovingOutTenancy";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "PreparationService";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "RequestTenancy";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | {
        __typename?: "UtilityAdministration";
        availableTeams: Array<
          | ({ __typename?: "AdministrationTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_AdministrationTeam_Fragment;
              };
            })
          | ({ __typename?: "ServiceTeam" } & {
              " $fragmentRefs"?: {
                ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment: ModalChangeResponsible_PossibleServiceTeam_ServiceTeam_Fragment;
              };
            })
        >;
      }
    | null;
};

export type ModalChangeResponsible_ChangeResponsibleMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type ModalChangeResponsible_ChangeResponsibleMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type ModalChangeServiceTeam_TeamsQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type ModalChangeServiceTeam_TeamsQuery = {
  __typename?: "Query";
  case?:
    | {
        __typename?: "CleaningService";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "CreateTenancy";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "EndTenancy";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "FindTenancyAdministration";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MiscAdministration";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MiscService";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MovingInService";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MovingInTenancy";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MovingOutService";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MovingOutTenancy";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "PreparationService";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "RequestTenancy";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | {
        __typename?: "UtilityAdministration";
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        serviceTeam?: { __typename?: "ServiceTeam"; id: string } | null;
      }
    | null;
};

export type ModalChangeServiceTeam_ServiceTeamMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type ModalChangeServiceTeam_ServiceTeamMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type CaseMetadataList_CancelScheduledMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
}>;

export type CaseMetadataList_CancelScheduledMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type CallToActionComplete_CompleteMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type CallToActionComplete_CompleteMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type ServiceRootPageCreateCommentMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type ServiceRootPageCreateCommentMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

type ServiceCaseScreen_CleaningService_Fragment = {
  __typename?: "CleaningService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_CleaningService_Fragment" };

type ServiceCaseScreen_CreateTenancy_Fragment = {
  __typename?: "CreateTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_CreateTenancy_Fragment" };

type ServiceCaseScreen_EndTenancy_Fragment = {
  __typename?: "EndTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_EndTenancy_Fragment" };

type ServiceCaseScreen_FindTenancyAdministration_Fragment = {
  __typename?: "FindTenancyAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & {
  " $fragmentName"?: "ServiceCaseScreen_FindTenancyAdministration_Fragment";
};

type ServiceCaseScreen_MiscAdministration_Fragment = {
  __typename?: "MiscAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MiscAdministration_Fragment" };

type ServiceCaseScreen_MiscService_Fragment = {
  __typename?: "MiscService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MiscService_Fragment" };

type ServiceCaseScreen_MovingInService_Fragment = {
  __typename?: "MovingInService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingInService_Fragment" };

type ServiceCaseScreen_MovingInTenancy_Fragment = {
  __typename?: "MovingInTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingInTenancy_Fragment" };

type ServiceCaseScreen_MovingOutService_Fragment = {
  __typename?: "MovingOutService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingOutService_Fragment" };

type ServiceCaseScreen_MovingOutTenancy_Fragment = {
  __typename?: "MovingOutTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingOutTenancy_Fragment" };

type ServiceCaseScreen_MovingSettlementAdministration_Fragment = {
  __typename?: "MovingSettlementAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & {
  " $fragmentName"?: "ServiceCaseScreen_MovingSettlementAdministration_Fragment";
};

type ServiceCaseScreen_PreparationService_Fragment = {
  __typename?: "PreparationService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_PreparationService_Fragment" };

type ServiceCaseScreen_RequestTenancy_Fragment = {
  __typename?: "RequestTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_RequestTenancy_Fragment" };

type ServiceCaseScreen_UtilityAdministration_Fragment = {
  __typename?: "UtilityAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_UtilityAdministration_Fragment" };

export type ServiceCaseScreenFragment =
  | ServiceCaseScreen_CleaningService_Fragment
  | ServiceCaseScreen_CreateTenancy_Fragment
  | ServiceCaseScreen_EndTenancy_Fragment
  | ServiceCaseScreen_FindTenancyAdministration_Fragment
  | ServiceCaseScreen_MiscAdministration_Fragment
  | ServiceCaseScreen_MiscService_Fragment
  | ServiceCaseScreen_MovingInService_Fragment
  | ServiceCaseScreen_MovingInTenancy_Fragment
  | ServiceCaseScreen_MovingOutService_Fragment
  | ServiceCaseScreen_MovingOutTenancy_Fragment
  | ServiceCaseScreen_MovingSettlementAdministration_Fragment
  | ServiceCaseScreen_PreparationService_Fragment
  | ServiceCaseScreen_RequestTenancy_Fragment
  | ServiceCaseScreen_UtilityAdministration_Fragment;

export type MovingCaseQueryQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type MovingCaseQueryQuery = {
  __typename?: "Query";
  case?:
    | ({ __typename?: "CleaningService" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_CleaningService_Fragment: ServiceCaseScreen_CleaningService_Fragment;
        };
      })
    | ({ __typename?: "CreateTenancy" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_CreateTenancy_Fragment: ServiceCaseScreen_CreateTenancy_Fragment;
        };
      })
    | ({ __typename?: "EndTenancy" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_EndTenancy_Fragment: ServiceCaseScreen_EndTenancy_Fragment;
        };
      })
    | ({ __typename?: "FindTenancyAdministration" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_FindTenancyAdministration_Fragment: ServiceCaseScreen_FindTenancyAdministration_Fragment;
        };
      })
    | ({ __typename?: "MiscAdministration" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MiscAdministration_Fragment: ServiceCaseScreen_MiscAdministration_Fragment;
        };
      })
    | ({ __typename?: "MiscService" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MiscService_Fragment: ServiceCaseScreen_MiscService_Fragment;
        };
      })
    | ({ __typename?: "MovingInService" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingInService_Fragment: ServiceCaseScreen_MovingInService_Fragment;
        };
      })
    | ({ __typename?: "MovingInTenancy" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingInTenancy_Fragment: ServiceCaseScreen_MovingInTenancy_Fragment;
        };
      })
    | ({ __typename?: "MovingOutService" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingOutService_Fragment: ServiceCaseScreen_MovingOutService_Fragment;
        };
      })
    | ({ __typename?: "MovingOutTenancy" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingOutTenancy_Fragment: ServiceCaseScreen_MovingOutTenancy_Fragment;
        };
      })
    | ({ __typename?: "MovingSettlementAdministration" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingSettlementAdministration_Fragment: ServiceCaseScreen_MovingSettlementAdministration_Fragment;
        };
      })
    | ({ __typename?: "PreparationService" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_PreparationService_Fragment: ServiceCaseScreen_PreparationService_Fragment;
        };
      })
    | ({ __typename?: "RequestTenancy" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_RequestTenancy_Fragment: ServiceCaseScreen_RequestTenancy_Fragment;
        };
      })
    | ({ __typename?: "UtilityAdministration" } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_UtilityAdministration_Fragment: ServiceCaseScreen_UtilityAdministration_Fragment;
        };
      })
    | null;
};

export type SaveInspectionMutationVariables = Exact<{
  input: BaseInspectionInput;
}>;

export type SaveInspectionMutation = {
  __typename?: "Mutation";
  caseInspectionSave?: {
    __typename?: "CaseInspectionSaveMutationPayload";
    errors: Array<string>;
  } | null;
};

export type ProcessInspectionMutationVariables = Exact<{
  input: BaseInspectionInput;
}>;

export type ProcessInspectionMutation = {
  __typename?: "Mutation";
  caseInspectionProcess?: {
    __typename?: "CaseInspectionProcessMutationPayload";
    errors: Array<string>;
  } | null;
};

export type SaveInspectionAnswerMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  areaId: Scalars["ID"]["input"];
  subjectId: Scalars["ID"]["input"];
  rating: Scalars["Int"]["input"];
  position: Scalars["Int"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SaveInspectionAnswerMutation = {
  __typename?: "Mutation";
  saveInspectionAnswer?: {
    __typename?: "SaveInspectionAnswerMutationPayload";
    errors: Array<string>;
  } | null;
};

export type DeleteInspectionAnswerMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  areaId: Scalars["ID"]["input"];
  subjectId: Scalars["ID"]["input"];
}>;

export type DeleteInspectionAnswerMutation = {
  __typename?: "Mutation";
  deleteInspectionAnswer?: {
    __typename?: "DeleteInspectionAnswerMutationPayload";
    errors: Array<string>;
  } | null;
};

export type ServiceCasesHeaderFragmentQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  where: CaseWhereInput;
}>;

export type ServiceCasesHeaderFragmentQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    records: Array<
      | ({ __typename?: "CleaningService" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_CleaningService_Fragment: Service_CaseDefinitionCaseFragment_CleaningService_Fragment;
          };
        })
      | ({ __typename?: "CreateTenancy" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment: Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment;
          };
        })
      | ({ __typename?: "EndTenancy" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_EndTenancy_Fragment: Service_CaseDefinitionCaseFragment_EndTenancy_Fragment;
          };
        })
      | ({ __typename?: "FindTenancyAdministration" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment: Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscAdministration" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment: Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscService" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MiscService_Fragment: Service_CaseDefinitionCaseFragment_MiscService_Fragment;
          };
        })
      | ({ __typename?: "MovingInService" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MovingInService_Fragment: Service_CaseDefinitionCaseFragment_MovingInService_Fragment;
          };
        })
      | ({ __typename?: "MovingInTenancy" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment: Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingOutService" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MovingOutService_Fragment: Service_CaseDefinitionCaseFragment_MovingOutService_Fragment;
          };
        })
      | ({ __typename?: "MovingOutTenancy" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment: Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingSettlementAdministration" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment: Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment;
          };
        })
      | ({ __typename?: "PreparationService" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_PreparationService_Fragment: Service_CaseDefinitionCaseFragment_PreparationService_Fragment;
          };
        })
      | ({ __typename?: "RequestTenancy" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment: Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment;
          };
        })
      | ({ __typename?: "UtilityAdministration" } & {
          " $fragmentRefs"?: {
            Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment: Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment;
          };
        })
    >;
  };
};

export type Service_AttachmentCategoriesQueryVariables = Exact<{
  lang: Scalars["String"]["input"];
}>;

export type Service_AttachmentCategoriesQuery = {
  __typename?: "Query";
  attachmentCategories: Array<{
    __typename?: "AttachmentCategory";
    id: string;
    nameDa: string;
    nameEn: string;
  }>;
};

export type AttachmentCategorySelector_UpdateAttachmentMutationVariables =
  Exact<{
    caseId: Scalars["ID"]["input"];
    event: CaseEventEnum;
    input?: InputMaybe<CaseEventInput>;
  }>;

export type AttachmentCategorySelector_UpdateAttachmentMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type TabTimeRegistration_AddTimeRegistrationMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type TabTimeRegistration_AddTimeRegistrationMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type TabTimeRegistration_UpdateTimeRegistrationMutationVariables =
  Exact<{
    timelogId: Scalars["ID"]["input"];
    timelogAccountId: Scalars["ID"]["input"];
    timelogCategoryId: Scalars["ID"]["input"];
    timelogDate: Scalars["ISO8601Date"]["input"];
    timelogHoursWithoutMinutes: Scalars["Int"]["input"];
    timelogMinutesWithoutHours: Scalars["Int"]["input"];
    timelogNote?: InputMaybe<Scalars["String"]["input"]>;
  }>;

export type TabTimeRegistration_UpdateTimeRegistrationMutation = {
  __typename?: "Mutation";
  timelogUpdate?: {
    __typename?: "TimelogUpdateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type TabTimeRegistration_RemoveTimeRegistrationMutationVariables =
  Exact<{
    timelogId: Scalars["ID"]["input"];
  }>;

export type TabTimeRegistration_RemoveTimeRegistrationMutation = {
  __typename?: "Mutation";
  timelogDelete?: {
    __typename?: "TimelogDeleteMutationPayload";
    errors: Array<string>;
    result?: { __typename?: "Timelog"; id: string } | null;
  } | null;
};

type ServiceCalendar_Case_CleaningService_Fragment = {
  __typename?: "CleaningService";
  canSchedule: boolean;
  maySchedule: boolean;
  canReschedule: boolean;
  mayReschedule: boolean;
  canChangeTask: boolean;
  mayChangeTask: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_CleaningService_Fragment" };

type ServiceCalendar_Case_CreateTenancy_Fragment = {
  __typename?: "CreateTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_CreateTenancy_Fragment" };

type ServiceCalendar_Case_EndTenancy_Fragment = {
  __typename?: "EndTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_EndTenancy_Fragment" };

type ServiceCalendar_Case_FindTenancyAdministration_Fragment = {
  __typename?: "FindTenancyAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & {
  " $fragmentName"?: "ServiceCalendar_Case_FindTenancyAdministration_Fragment";
};

type ServiceCalendar_Case_MiscAdministration_Fragment = {
  __typename?: "MiscAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_MiscAdministration_Fragment" };

type ServiceCalendar_Case_MiscService_Fragment = {
  __typename?: "MiscService";
  canSchedule: boolean;
  maySchedule: boolean;
  canReschedule: boolean;
  mayReschedule: boolean;
  canChangeTask: boolean;
  mayChangeTask: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_MiscService_Fragment" };

type ServiceCalendar_Case_MovingInService_Fragment = {
  __typename?: "MovingInService";
  canSchedule: boolean;
  maySchedule: boolean;
  canReschedule: boolean;
  mayReschedule: boolean;
  canChangeTask: boolean;
  mayChangeTask: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_MovingInService_Fragment" };

type ServiceCalendar_Case_MovingInTenancy_Fragment = {
  __typename?: "MovingInTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_MovingInTenancy_Fragment" };

type ServiceCalendar_Case_MovingOutService_Fragment = {
  __typename?: "MovingOutService";
  canSchedule: boolean;
  maySchedule: boolean;
  canReschedule: boolean;
  mayReschedule: boolean;
  canChangeTask: boolean;
  mayChangeTask: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_MovingOutService_Fragment" };

type ServiceCalendar_Case_MovingOutTenancy_Fragment = {
  __typename?: "MovingOutTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_MovingOutTenancy_Fragment" };

type ServiceCalendar_Case_MovingSettlementAdministration_Fragment = {
  __typename?: "MovingSettlementAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & {
  " $fragmentName"?: "ServiceCalendar_Case_MovingSettlementAdministration_Fragment";
};

type ServiceCalendar_Case_PreparationService_Fragment = {
  __typename?: "PreparationService";
  canSchedule: boolean;
  maySchedule: boolean;
  canReschedule: boolean;
  mayReschedule: boolean;
  canChangeTask: boolean;
  mayChangeTask: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_PreparationService_Fragment" };

type ServiceCalendar_Case_RequestTenancy_Fragment = {
  __typename?: "RequestTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & { " $fragmentName"?: "ServiceCalendar_Case_RequestTenancy_Fragment" };

type ServiceCalendar_Case_UtilityAdministration_Fragment = {
  __typename?: "UtilityAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  canChangeResponsible: boolean;
  mayChangeResponsible: boolean;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  responsible?: { __typename?: "CaseUser"; id: string; name: string } | null;
} & {
  " $fragmentName"?: "ServiceCalendar_Case_UtilityAdministration_Fragment";
};

export type ServiceCalendar_CaseFragment =
  | ServiceCalendar_Case_CleaningService_Fragment
  | ServiceCalendar_Case_CreateTenancy_Fragment
  | ServiceCalendar_Case_EndTenancy_Fragment
  | ServiceCalendar_Case_FindTenancyAdministration_Fragment
  | ServiceCalendar_Case_MiscAdministration_Fragment
  | ServiceCalendar_Case_MiscService_Fragment
  | ServiceCalendar_Case_MovingInService_Fragment
  | ServiceCalendar_Case_MovingInTenancy_Fragment
  | ServiceCalendar_Case_MovingOutService_Fragment
  | ServiceCalendar_Case_MovingOutTenancy_Fragment
  | ServiceCalendar_Case_MovingSettlementAdministration_Fragment
  | ServiceCalendar_Case_PreparationService_Fragment
  | ServiceCalendar_Case_RequestTenancy_Fragment
  | ServiceCalendar_Case_UtilityAdministration_Fragment;

export type ServiceCalendar_ScheduleMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  startAfter?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  completeBefore?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledTime?: InputMaybe<Scalars["String"]["input"]>;
  responsibleId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type ServiceCalendar_ScheduleMutation = {
  __typename?: "Mutation";
  casePlanningUpdate?: {
    __typename?: "CasePlanningUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type ServiceCalendar_UnassignedCasesQueryVariables = Exact<{
  where: CaseWhereInput;
  limit: Scalars["Int"]["input"];
  orderBy?: InputMaybe<CaseOrderByEnum>;
}>;

export type ServiceCalendar_UnassignedCasesQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    records: Array<
      | ({ __typename?: "CleaningService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_CleaningService_Fragment: ServiceCalendar_Case_CleaningService_Fragment;
          };
        })
      | ({ __typename?: "CreateTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_CreateTenancy_Fragment: ServiceCalendar_Case_CreateTenancy_Fragment;
          };
        })
      | ({ __typename?: "EndTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_EndTenancy_Fragment: ServiceCalendar_Case_EndTenancy_Fragment;
          };
        })
      | ({ __typename?: "FindTenancyAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_FindTenancyAdministration_Fragment: ServiceCalendar_Case_FindTenancyAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MiscAdministration_Fragment: ServiceCalendar_Case_MiscAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MiscService_Fragment: ServiceCalendar_Case_MiscService_Fragment;
          };
        })
      | ({ __typename?: "MovingInService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingInService_Fragment: ServiceCalendar_Case_MovingInService_Fragment;
          };
        })
      | ({ __typename?: "MovingInTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingInTenancy_Fragment: ServiceCalendar_Case_MovingInTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingOutService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingOutService_Fragment: ServiceCalendar_Case_MovingOutService_Fragment;
          };
        })
      | ({ __typename?: "MovingOutTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingOutTenancy_Fragment: ServiceCalendar_Case_MovingOutTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingSettlementAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingSettlementAdministration_Fragment: ServiceCalendar_Case_MovingSettlementAdministration_Fragment;
          };
        })
      | ({ __typename?: "PreparationService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_PreparationService_Fragment: ServiceCalendar_Case_PreparationService_Fragment;
          };
        })
      | ({ __typename?: "RequestTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_RequestTenancy_Fragment: ServiceCalendar_Case_RequestTenancy_Fragment;
          };
        })
      | ({ __typename?: "UtilityAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_UtilityAdministration_Fragment: ServiceCalendar_Case_UtilityAdministration_Fragment;
          };
        })
    >;
  };
};

export type ServiceCalendar_ScheduledCasesQueryVariables = Exact<{
  where: CaseWhereInput;
  limit: Scalars["Int"]["input"];
}>;

export type ServiceCalendar_ScheduledCasesQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    records: Array<
      | ({ __typename?: "CleaningService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_CleaningService_Fragment: ServiceCalendar_Case_CleaningService_Fragment;
          };
        })
      | ({ __typename?: "CreateTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_CreateTenancy_Fragment: ServiceCalendar_Case_CreateTenancy_Fragment;
          };
        })
      | ({ __typename?: "EndTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_EndTenancy_Fragment: ServiceCalendar_Case_EndTenancy_Fragment;
          };
        })
      | ({ __typename?: "FindTenancyAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_FindTenancyAdministration_Fragment: ServiceCalendar_Case_FindTenancyAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MiscAdministration_Fragment: ServiceCalendar_Case_MiscAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MiscService_Fragment: ServiceCalendar_Case_MiscService_Fragment;
          };
        })
      | ({ __typename?: "MovingInService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingInService_Fragment: ServiceCalendar_Case_MovingInService_Fragment;
          };
        })
      | ({ __typename?: "MovingInTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingInTenancy_Fragment: ServiceCalendar_Case_MovingInTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingOutService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingOutService_Fragment: ServiceCalendar_Case_MovingOutService_Fragment;
          };
        })
      | ({ __typename?: "MovingOutTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingOutTenancy_Fragment: ServiceCalendar_Case_MovingOutTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingSettlementAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_MovingSettlementAdministration_Fragment: ServiceCalendar_Case_MovingSettlementAdministration_Fragment;
          };
        })
      | ({ __typename?: "PreparationService" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_PreparationService_Fragment: ServiceCalendar_Case_PreparationService_Fragment;
          };
        })
      | ({ __typename?: "RequestTenancy" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_RequestTenancy_Fragment: ServiceCalendar_Case_RequestTenancy_Fragment;
          };
        })
      | ({ __typename?: "UtilityAdministration" } & {
          " $fragmentRefs"?: {
            ServiceCalendar_Case_UtilityAdministration_Fragment: ServiceCalendar_Case_UtilityAdministration_Fragment;
          };
        })
    >;
  };
};

export type ServiceCalendar_ResponsibleOptionsQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type ServiceCalendar_ResponsibleOptionsQuery = {
  __typename?: "Query";
  case?:
    | {
        __typename?: "CleaningService";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "CreateTenancy";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "EndTenancy";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "FindTenancyAdministration";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MiscAdministration";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MiscService";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MovingInService";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MovingInTenancy";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MovingOutService";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MovingOutTenancy";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "PreparationService";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "RequestTenancy";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | {
        __typename?: "UtilityAdministration";
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      }
    | null;
};

type Service_CaseDefinitionCaseFragment_CleaningService_Fragment = {
  __typename: "CleaningService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_CleaningService_Fragment";
};

type Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment = {
  __typename: "CreateTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment";
};

type Service_CaseDefinitionCaseFragment_EndTenancy_Fragment = {
  __typename: "EndTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_EndTenancy_Fragment";
};

type Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment = {
  __typename: "FindTenancyAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment";
};

type Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment = {
  __typename: "MiscAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment";
};

type Service_CaseDefinitionCaseFragment_MiscService_Fragment = {
  __typename: "MiscService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MiscService_Fragment";
};

type Service_CaseDefinitionCaseFragment_MovingInService_Fragment = {
  __typename: "MovingInService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MovingInService_Fragment";
};

type Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment = {
  __typename: "MovingInTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment";
};

type Service_CaseDefinitionCaseFragment_MovingOutService_Fragment = {
  __typename: "MovingOutService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MovingOutService_Fragment";
};

type Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment = {
  __typename: "MovingOutTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment";
};

type Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment =
  {
    __typename: "MovingSettlementAdministration";
    id: string;
    name: string;
    shortName: string;
    type: CaseTypeEnum;
    icon: string;
    attention: CaseAttentionEnum;
    awaiting?: string | null;
    state: string;
    stateText: string;
    unreadCommentsCount: number;
  } & {
    " $fragmentName"?: "Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment";
  };

type Service_CaseDefinitionCaseFragment_PreparationService_Fragment = {
  __typename: "PreparationService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_PreparationService_Fragment";
};

type Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment = {
  __typename: "RequestTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment";
};

type Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment = {
  __typename: "UtilityAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  unreadCommentsCount: number;
} & {
  " $fragmentName"?: "Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment";
};

export type Service_CaseDefinitionCaseFragmentFragment =
  | Service_CaseDefinitionCaseFragment_CleaningService_Fragment
  | Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment
  | Service_CaseDefinitionCaseFragment_EndTenancy_Fragment
  | Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment
  | Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment
  | Service_CaseDefinitionCaseFragment_MiscService_Fragment
  | Service_CaseDefinitionCaseFragment_MovingInService_Fragment
  | Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment
  | Service_CaseDefinitionCaseFragment_MovingOutService_Fragment
  | Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment
  | Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment
  | Service_CaseDefinitionCaseFragment_PreparationService_Fragment
  | Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment
  | Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment;

export type Service_CaseCommentFragment = {
  __typename?: "CaseComment";
  id: string;
  message: string;
  createdAt: any;
  important: boolean;
  readAt?: any | null;
  type: CaseCommentTypeEnum;
  stateFrom?: string | null;
  stateTo?: string | null;
  stateDescription: string;
  smsMessage: boolean;
  emailMessage: boolean;
  assets: Array<{
    __typename?: "File";
    id: string;
    fileName: string;
    fileType: string;
    url: string;
    largeUrl: string;
    thumbUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
  }>;
  sender: { __typename?: "User"; id: string; name: string };
  recipient?: { __typename?: "User"; id: string; name: string } | null;
} & { " $fragmentName"?: "Service_CaseCommentFragment" };

export type ServiceRootPage_CaseCommentUserFragment = {
  __typename?: "CaseCommentUserOption";
  id: string;
  label: string;
} & { " $fragmentName"?: "ServiceRootPage_CaseCommentUserFragment" };

type ServiceRootPage_Case_CleaningService_Fragment = ({
  __typename?: "CleaningService";
  mayReceive: boolean;
  canReceive: boolean;
  maySchedule: boolean;
  canSchedule: boolean;
  mayReschedule: boolean;
  canReschedule: boolean;
  mayCancelScheduled: boolean;
  canCancelScheduled: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_CleaningService_Fragment: Service_CaseDefinitionCaseFragment_CleaningService_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_CleaningService_Fragment" };

type ServiceRootPage_Case_CreateTenancy_Fragment = ({
  __typename?: "CreateTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment: Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_CreateTenancy_Fragment" };

type ServiceRootPage_Case_EndTenancy_Fragment = ({
  __typename?: "EndTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_EndTenancy_Fragment: Service_CaseDefinitionCaseFragment_EndTenancy_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_EndTenancy_Fragment" };

type ServiceRootPage_Case_FindTenancyAdministration_Fragment = ({
  __typename?: "FindTenancyAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment: Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment;
  };
}) & {
  " $fragmentName"?: "ServiceRootPage_Case_FindTenancyAdministration_Fragment";
};

type ServiceRootPage_Case_MiscAdministration_Fragment = ({
  __typename?: "MiscAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment: Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_MiscAdministration_Fragment" };

type ServiceRootPage_Case_MiscService_Fragment = ({
  __typename?: "MiscService";
  mayReceive: boolean;
  canReceive: boolean;
  maySchedule: boolean;
  canSchedule: boolean;
  mayReschedule: boolean;
  canReschedule: boolean;
  mayCancelScheduled: boolean;
  canCancelScheduled: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MiscService_Fragment: Service_CaseDefinitionCaseFragment_MiscService_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_MiscService_Fragment" };

type ServiceRootPage_Case_MovingInService_Fragment = ({
  __typename?: "MovingInService";
  mayReceive: boolean;
  canReceive: boolean;
  maySchedule: boolean;
  canSchedule: boolean;
  mayReschedule: boolean;
  canReschedule: boolean;
  mayCancelScheduled: boolean;
  canCancelScheduled: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MovingInService_Fragment: Service_CaseDefinitionCaseFragment_MovingInService_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_MovingInService_Fragment" };

type ServiceRootPage_Case_MovingInTenancy_Fragment = ({
  __typename?: "MovingInTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment: Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_MovingInTenancy_Fragment" };

type ServiceRootPage_Case_MovingOutService_Fragment = ({
  __typename?: "MovingOutService";
  mayReceive: boolean;
  canReceive: boolean;
  maySchedule: boolean;
  canSchedule: boolean;
  mayReschedule: boolean;
  canReschedule: boolean;
  mayCancelScheduled: boolean;
  canCancelScheduled: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MovingOutService_Fragment: Service_CaseDefinitionCaseFragment_MovingOutService_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_MovingOutService_Fragment" };

type ServiceRootPage_Case_MovingOutTenancy_Fragment = ({
  __typename?: "MovingOutTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment: Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_MovingOutTenancy_Fragment" };

type ServiceRootPage_Case_MovingSettlementAdministration_Fragment = ({
  __typename?: "MovingSettlementAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment: Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment;
  };
}) & {
  " $fragmentName"?: "ServiceRootPage_Case_MovingSettlementAdministration_Fragment";
};

type ServiceRootPage_Case_PreparationService_Fragment = ({
  __typename?: "PreparationService";
  mayReceive: boolean;
  canReceive: boolean;
  maySchedule: boolean;
  canSchedule: boolean;
  mayReschedule: boolean;
  canReschedule: boolean;
  mayCancelScheduled: boolean;
  canCancelScheduled: boolean;
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_PreparationService_Fragment: Service_CaseDefinitionCaseFragment_PreparationService_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_PreparationService_Fragment" };

type ServiceRootPage_Case_RequestTenancy_Fragment = ({
  __typename?: "RequestTenancy";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment: Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment;
  };
}) & { " $fragmentName"?: "ServiceRootPage_Case_RequestTenancy_Fragment" };

type ServiceRootPage_Case_UtilityAdministration_Fragment = ({
  __typename?: "UtilityAdministration";
  id: string;
  name: string;
  title: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  completedDate?: any | null;
  body: string;
  unreadCommentsCount: number;
  mayAddComment: boolean;
  canAwait: boolean;
  mayAwait: boolean;
  isArchived: boolean;
  tenantWillAttend?: boolean | null;
  isService: boolean;
  scheduledTime?: string | null;
  mayCreate: boolean;
  mayComplete: boolean;
  mayCancel: boolean;
  mayAddTimelog: boolean;
  mayAddFollower: boolean;
  mayRemoveFollower: boolean;
  mayChangeResponsible: boolean;
  mayAddAttachment: boolean;
  mayRemoveAttachment: boolean;
  mayConfigureRepeat: boolean;
  mayToggleCheck: boolean;
  canUpdate: boolean;
  canComplete: boolean;
  canCancel: boolean;
  canAddComment: boolean;
  canSendCommentAsSms: boolean;
  canAddAttachment: boolean;
  canRemoveAttachment: boolean;
  canAddFollower: boolean;
  canRemoveFollower: boolean;
  canChangeResponsible: boolean;
  canAddTimelog: boolean;
  canToggleCheck: boolean;
  canConfigureRepeat: boolean;
  canShowTimelogs: boolean;
  canShowAttention: boolean;
  checks?: Array<{
    __typename?: "CaseCheck";
    id: string;
    label: string;
    value?: boolean | null;
  }> | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  comments: Array<
    { __typename?: "CaseComment" } & {
      " $fragmentRefs"?: {
        Service_CaseCommentFragment: Service_CaseCommentFragment;
      };
    }
  >;
  attachments: Array<{
    __typename?: "CaseAttachment";
    id: string;
    fileName: string;
    originalUrl: string;
    thumbUrl: string;
    largeUrl: string;
    isPdf: boolean;
    isImage: boolean;
    headSignedUrl: string;
    category?: {
      __typename?: "AttachmentCategory";
      id: string;
      nameDa: string;
      nameEn: string;
    } | null;
  }>;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    city: string;
    postalCode: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  responsible?: { __typename: "CaseUser"; id: string; name: string } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      address?: string | null;
      city?: string | null;
      postalCode?: string | null;
    };
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            enumOptions?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              availableInService: boolean;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
  property?: {
    __typename?: "Property";
    name: string;
    owner: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
    administrator: {
      __typename?: "Company";
      name: string;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      vat?: string | null;
    };
  } | null;
  availableTeams: Array<
    | {
        __typename?: "AdministrationTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        name: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
  >;
  whyAttention: Array<{
    __typename?: "CaseAttentionCondition";
    texts: Array<string>;
  }>;
  commentUsers: Array<
    { __typename?: "CaseCommentUserOption" } & {
      " $fragmentRefs"?: {
        ServiceRootPage_CaseCommentUserFragment: ServiceRootPage_CaseCommentUserFragment;
      };
    }
  >;
  timelogs: Array<{
    __typename?: "Timelog";
    id: string;
    hoursWithoutMinutes: number;
    minutesWithoutHours: number;
    date: any;
    note?: string | null;
    canDestroy: boolean;
    canUpdate: boolean;
    account: { __typename?: "TimelogAccount"; id: string; name: string };
    category: { __typename?: "TimelogCategory"; id: string; name: string };
    user: { __typename?: "User"; id: string; name: string };
  }>;
  timelogAccount?: {
    __typename?: "TimelogAccount";
    id: string;
    name: string;
    categories: Array<{
      __typename?: "TimelogCategory";
      id: string;
      name: string;
    }>;
  } | null;
} & {
  " $fragmentRefs"?: {
    Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment: Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment;
  };
}) & {
  " $fragmentName"?: "ServiceRootPage_Case_UtilityAdministration_Fragment";
};

export type ServiceRootPage_CaseFragment =
  | ServiceRootPage_Case_CleaningService_Fragment
  | ServiceRootPage_Case_CreateTenancy_Fragment
  | ServiceRootPage_Case_EndTenancy_Fragment
  | ServiceRootPage_Case_FindTenancyAdministration_Fragment
  | ServiceRootPage_Case_MiscAdministration_Fragment
  | ServiceRootPage_Case_MiscService_Fragment
  | ServiceRootPage_Case_MovingInService_Fragment
  | ServiceRootPage_Case_MovingInTenancy_Fragment
  | ServiceRootPage_Case_MovingOutService_Fragment
  | ServiceRootPage_Case_MovingOutTenancy_Fragment
  | ServiceRootPage_Case_MovingSettlementAdministration_Fragment
  | ServiceRootPage_Case_PreparationService_Fragment
  | ServiceRootPage_Case_RequestTenancy_Fragment
  | ServiceRootPage_Case_UtilityAdministration_Fragment;

export type ServiceRootPageAddAttachmentMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type ServiceRootPageAddAttachmentMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type ServiceRootPage_CaseByIdQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum> | CaseCommentTypeEnum>;
}>;

export type ServiceRootPage_CaseByIdQuery = {
  __typename?: "Query";
  case?:
    | ({ __typename?: "CleaningService" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_CleaningService_Fragment: ServiceRootPage_Case_CleaningService_Fragment;
        };
      })
    | ({ __typename?: "CreateTenancy" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_CreateTenancy_Fragment: ServiceRootPage_Case_CreateTenancy_Fragment;
        };
      })
    | ({ __typename?: "EndTenancy" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_EndTenancy_Fragment: ServiceRootPage_Case_EndTenancy_Fragment;
        };
      })
    | ({ __typename?: "FindTenancyAdministration" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_FindTenancyAdministration_Fragment: ServiceRootPage_Case_FindTenancyAdministration_Fragment;
        };
      })
    | ({ __typename?: "MiscAdministration" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MiscAdministration_Fragment: ServiceRootPage_Case_MiscAdministration_Fragment;
        };
      })
    | ({ __typename?: "MiscService" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MiscService_Fragment: ServiceRootPage_Case_MiscService_Fragment;
        };
      })
    | ({ __typename?: "MovingInService" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MovingInService_Fragment: ServiceRootPage_Case_MovingInService_Fragment;
        };
      })
    | ({ __typename?: "MovingInTenancy" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MovingInTenancy_Fragment: ServiceRootPage_Case_MovingInTenancy_Fragment;
        };
      })
    | ({ __typename?: "MovingOutService" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MovingOutService_Fragment: ServiceRootPage_Case_MovingOutService_Fragment;
        };
      })
    | ({ __typename?: "MovingOutTenancy" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MovingOutTenancy_Fragment: ServiceRootPage_Case_MovingOutTenancy_Fragment;
        };
      })
    | ({ __typename?: "MovingSettlementAdministration" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_MovingSettlementAdministration_Fragment: ServiceRootPage_Case_MovingSettlementAdministration_Fragment;
        };
      })
    | ({ __typename?: "PreparationService" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_PreparationService_Fragment: ServiceRootPage_Case_PreparationService_Fragment;
        };
      })
    | ({ __typename?: "RequestTenancy" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_RequestTenancy_Fragment: ServiceRootPage_Case_RequestTenancy_Fragment;
        };
      })
    | ({ __typename?: "UtilityAdministration" } & {
        " $fragmentRefs"?: {
          ServiceRootPage_Case_UtilityAdministration_Fragment: ServiceRootPage_Case_UtilityAdministration_Fragment;
        };
      })
    | null;
};

export type ServiceRootPage_CasesQueryVariables = Exact<{
  where: CaseWhereInput;
  orderBy: CaseOrderByEnum;
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum> | CaseCommentTypeEnum>;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type ServiceRootPage_CasesQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    records: Array<
      | ({ __typename?: "CleaningService" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_CleaningService_Fragment: ServiceRootPage_Case_CleaningService_Fragment;
            Service_CaseDefinitionCaseFragment_CleaningService_Fragment: Service_CaseDefinitionCaseFragment_CleaningService_Fragment;
          };
        })
      | ({ __typename?: "CreateTenancy" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_CreateTenancy_Fragment: ServiceRootPage_Case_CreateTenancy_Fragment;
            Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment: Service_CaseDefinitionCaseFragment_CreateTenancy_Fragment;
          };
        })
      | ({ __typename?: "EndTenancy" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_EndTenancy_Fragment: ServiceRootPage_Case_EndTenancy_Fragment;
            Service_CaseDefinitionCaseFragment_EndTenancy_Fragment: Service_CaseDefinitionCaseFragment_EndTenancy_Fragment;
          };
        })
      | ({ __typename?: "FindTenancyAdministration" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_FindTenancyAdministration_Fragment: ServiceRootPage_Case_FindTenancyAdministration_Fragment;
            Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment: Service_CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscAdministration" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MiscAdministration_Fragment: ServiceRootPage_Case_MiscAdministration_Fragment;
            Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment: Service_CaseDefinitionCaseFragment_MiscAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscService" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MiscService_Fragment: ServiceRootPage_Case_MiscService_Fragment;
            Service_CaseDefinitionCaseFragment_MiscService_Fragment: Service_CaseDefinitionCaseFragment_MiscService_Fragment;
          };
        })
      | ({ __typename?: "MovingInService" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MovingInService_Fragment: ServiceRootPage_Case_MovingInService_Fragment;
            Service_CaseDefinitionCaseFragment_MovingInService_Fragment: Service_CaseDefinitionCaseFragment_MovingInService_Fragment;
          };
        })
      | ({ __typename?: "MovingInTenancy" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MovingInTenancy_Fragment: ServiceRootPage_Case_MovingInTenancy_Fragment;
            Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment: Service_CaseDefinitionCaseFragment_MovingInTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingOutService" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MovingOutService_Fragment: ServiceRootPage_Case_MovingOutService_Fragment;
            Service_CaseDefinitionCaseFragment_MovingOutService_Fragment: Service_CaseDefinitionCaseFragment_MovingOutService_Fragment;
          };
        })
      | ({ __typename?: "MovingOutTenancy" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MovingOutTenancy_Fragment: ServiceRootPage_Case_MovingOutTenancy_Fragment;
            Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment: Service_CaseDefinitionCaseFragment_MovingOutTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingSettlementAdministration" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_MovingSettlementAdministration_Fragment: ServiceRootPage_Case_MovingSettlementAdministration_Fragment;
            Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment: Service_CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment;
          };
        })
      | ({ __typename?: "PreparationService" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_PreparationService_Fragment: ServiceRootPage_Case_PreparationService_Fragment;
            Service_CaseDefinitionCaseFragment_PreparationService_Fragment: Service_CaseDefinitionCaseFragment_PreparationService_Fragment;
          };
        })
      | ({ __typename?: "RequestTenancy" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_RequestTenancy_Fragment: ServiceRootPage_Case_RequestTenancy_Fragment;
            Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment: Service_CaseDefinitionCaseFragment_RequestTenancy_Fragment;
          };
        })
      | ({ __typename?: "UtilityAdministration" } & {
          " $fragmentRefs"?: {
            ServiceRootPage_Case_UtilityAdministration_Fragment: ServiceRootPage_Case_UtilityAdministration_Fragment;
            Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment: Service_CaseDefinitionCaseFragment_UtilityAdministration_Fragment;
          };
        })
    >;
  };
};

export type ServiceFiltersDataQueryVariables = Exact<{
  teamId: Scalars["ID"]["input"];
  propertyIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
}>;

export type ServiceFiltersDataQuery = {
  __typename?: "Query";
  team?:
    | {
        __typename?: "AdministrationTeam";
        id: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | {
        __typename?: "ServiceTeam";
        id: string;
        members: Array<{ __typename?: "User"; id: string; name: string }>;
      }
    | null;
  caseDefinitions: Array<{
    __typename?: "CaseDefinition";
    type: CaseTypeEnum;
    cases: { __typename?: "CaseList"; total: number };
  }>;
};

export type Service_ServiceTeamPropertyFragment = {
  __typename?: "Property";
  id: string;
  name: string;
  activeServiceCasesCount: number;
} & { " $fragmentName"?: "Service_ServiceTeamPropertyFragment" };

export type Service_ServiceTeamPropertiesQueryVariables = Exact<{
  where?: InputMaybe<PropertyWhereInput>;
}>;

export type Service_ServiceTeamPropertiesQuery = {
  __typename?: "Query";
  properties: {
    __typename?: "PropertyList";
    records: Array<
      { __typename?: "Property" } & {
        " $fragmentRefs"?: {
          Service_ServiceTeamPropertyFragment: Service_ServiceTeamPropertyFragment;
        };
      }
    >;
  };
};

export type CurrentUserFragmentFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  isSystemAdministrator: boolean;
  isAdministrator: boolean;
  isServiceAdministrator: boolean;
  isServiceCaseWorker: boolean;
  locale: string;
  teams: Array<{ __typename?: "AdministrationTeam"; id: string; name: string }>;
  serviceTeams: Array<{ __typename?: "ServiceTeam"; id: string; name: string }>;
} & { " $fragmentName"?: "CurrentUserFragmentFragment" };

export type CurrentUser_ServiceQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUser_ServiceQuery = {
  __typename?: "Query";
  currentUser?:
    | ({ __typename?: "User" } & {
        " $fragmentRefs"?: {
          CurrentUserFragmentFragment: CurrentUserFragmentFragment;
        };
      })
    | null;
};

export const ModalChangeResponsible_PossibleServiceTeamFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ModalChangeResponsible_PossibleServiceTeam",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "members" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModalChangeResponsible_PossibleServiceTeamFragment,
  unknown
>;
export const ServiceCaseScreenFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCaseScreen" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "inspected" } },
          { kind: "Field", name: { kind: "Name", value: "processing" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "inspection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayProcess" } },
                { kind: "Field", name: { kind: "Name", value: "canProcess" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cleaning" } },
                { kind: "Field", name: { kind: "Name", value: "other" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyMissing" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "document" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceCaseScreenFragment, unknown>;
export const ServiceCalendar_CaseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCalendar_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canChangeResponsible" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayChangeResponsible" },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceCalendar_CaseFragment, unknown>;
export const Service_CaseDefinitionCaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Service_CaseDefinitionCaseFragmentFragment,
  unknown
>;
export const Service_CaseCommentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "important" } },
          { kind: "Field", name: { kind: "Name", value: "readAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "fileType" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "stateFrom" } },
          { kind: "Field", name: { kind: "Name", value: "stateTo" } },
          { kind: "Field", name: { kind: "Name", value: "stateDescription" } },
          { kind: "Field", name: { kind: "Name", value: "smsMessage" } },
          { kind: "Field", name: { kind: "Name", value: "emailMessage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Service_CaseCommentFragment, unknown>;
export const ServiceRootPage_CaseCommentUserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_CaseCommentUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseCommentUserOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceRootPage_CaseCommentUserFragment, unknown>;
export const ServiceRootPage_CaseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "completedDate" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayAddComment" } },
          { kind: "Field", name: { kind: "Name", value: "canAwait" } },
          { kind: "Field", name: { kind: "Name", value: "mayAwait" } },
          { kind: "Field", name: { kind: "Name", value: "isArchived" } },
          { kind: "Field", name: { kind: "Name", value: "tenantWillAttend" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "comments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "commentTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "commentTypes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Service_CaseComment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "originalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameDa" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameEn" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableInService",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableInService",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "administrator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isService" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "whyAttention" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "texts" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commentUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ServiceRootPage_CaseCommentUser",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hoursWithoutMinutes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minutesWithoutHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "canDestroy" } },
                { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "mayCreate" } },
          { kind: "Field", name: { kind: "Name", value: "mayComplete" } },
          { kind: "Field", name: { kind: "Name", value: "mayCancel" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddComment" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddTimelog" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddFollower" } },
          { kind: "Field", name: { kind: "Name", value: "mayRemoveFollower" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayChangeResponsible" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayAddAttachment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayRemoveAttachment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayConfigureRepeat" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayToggleCheck" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
          { kind: "Field", name: { kind: "Name", value: "canComplete" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "canAddComment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canSendCommentAsSms" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddAttachment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRemoveAttachment" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddFollower" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveFollower" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canChangeResponsible" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddTimelog" } },
          { kind: "Field", name: { kind: "Name", value: "canToggleCheck" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canConfigureRepeat" },
          },
          { kind: "Field", name: { kind: "Name", value: "canShowTimelogs" } },
          { kind: "Field", name: { kind: "Name", value: "canShowAttention" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogAccount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "important" } },
          { kind: "Field", name: { kind: "Name", value: "readAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "fileType" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "stateFrom" } },
          { kind: "Field", name: { kind: "Name", value: "stateTo" } },
          { kind: "Field", name: { kind: "Name", value: "stateDescription" } },
          { kind: "Field", name: { kind: "Name", value: "smsMessage" } },
          { kind: "Field", name: { kind: "Name", value: "emailMessage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_CaseCommentUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseCommentUserOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceRootPage_CaseFragment, unknown>;
export const Service_ServiceTeamPropertyFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_ServiceTeamProperty" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "activeServiceCasesCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Service_ServiceTeamPropertyFragment, unknown>;
export const CurrentUserFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CurrentUserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSystemAdministrator" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAdministrator" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceAdministrator" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceCaseWorker" },
          },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserFragmentFragment, unknown>;
export const AttachmentCover_RemoveAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AttachmentCover_RemoveAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttachmentCover_RemoveAttachmentMutation,
  AttachmentCover_RemoveAttachmentMutationVariables
>;
export const CallToActionReceive_ReceiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CallToActionReceive_Receive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CallToActionReceive_ReceiveMutation,
  CallToActionReceive_ReceiveMutationVariables
>;
export const CallToActionSchedule_ScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CallToActionSchedule_Schedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ISO8601Date" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "time" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseSchedule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scheduledDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scheduledTime" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "time" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CallToActionSchedule_ScheduleMutation,
  CallToActionSchedule_ScheduleMutationVariables
>;
export const ServiceCaseCheckbox_ToggleCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ServiceCaseCheckbox_ToggleCheck" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceCaseCheckbox_ToggleCheckMutation,
  ServiceCaseCheckbox_ToggleCheckMutationVariables
>;
export const CaseComment_ReadCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseComment_ReadComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "senderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseCommentRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "senderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "senderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseComment_ReadCommentMutation,
  CaseComment_ReadCommentMutationVariables
>;
export const ModalChangeResponsible_PossibleResponsibleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "ModalChangeResponsible_PossibleResponsible",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableTeams" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "forAssignment" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ModalChangeResponsible_PossibleServiceTeam",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ModalChangeResponsible_PossibleServiceTeam",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "members" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModalChangeResponsible_PossibleResponsibleQuery,
  ModalChangeResponsible_PossibleResponsibleQueryVariables
>;
export const ModalChangeResponsible_ChangeResponsibleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ModalChangeResponsible_ChangeResponsible" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModalChangeResponsible_ChangeResponsibleMutation,
  ModalChangeResponsible_ChangeResponsibleMutationVariables
>;
export const ModalChangeServiceTeam_TeamsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ModalChangeServiceTeam_Teams" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableTeams" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serviceTeam" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModalChangeServiceTeam_TeamsQuery,
  ModalChangeServiceTeam_TeamsQueryVariables
>;
export const ModalChangeServiceTeam_ServiceTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ModalChangeServiceTeam_ServiceTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModalChangeServiceTeam_ServiceTeamMutation,
  ModalChangeServiceTeam_ServiceTeamMutationVariables
>;
export const CaseMetadataList_CancelScheduledDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseMetadataList_CancelScheduled" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseMetadataList_CancelScheduledMutation,
  CaseMetadataList_CancelScheduledMutationVariables
>;
export const CallToActionComplete_CompleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CallToActionComplete_Complete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CallToActionComplete_CompleteMutation,
  CallToActionComplete_CompleteMutationVariables
>;
export const ServiceRootPageCreateCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ServiceRootPageCreateComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceRootPageCreateCommentMutation,
  ServiceRootPageCreateCommentMutationVariables
>;
export const MovingCaseQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MovingCaseQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ServiceCaseScreen" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCaseScreen" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "inspected" } },
          { kind: "Field", name: { kind: "Name", value: "processing" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "inspection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayProcess" } },
                { kind: "Field", name: { kind: "Name", value: "canProcess" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cleaning" } },
                { kind: "Field", name: { kind: "Name", value: "other" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyMissing" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "document" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MovingCaseQueryQuery,
  MovingCaseQueryQueryVariables
>;
export const SaveInspectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveInspection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BaseInspectionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseInspectionSave" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveInspectionMutation,
  SaveInspectionMutationVariables
>;
export const ProcessInspectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProcessInspection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BaseInspectionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseInspectionProcess" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProcessInspectionMutation,
  ProcessInspectionMutationVariables
>;
export const SaveInspectionAnswerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveInspectionAnswer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subjectId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "rating" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "position" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveInspectionAnswer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "subjectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "rating" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "rating" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "position" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "position" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveInspectionAnswerMutation,
  SaveInspectionAnswerMutationVariables
>;
export const DeleteInspectionAnswerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteInspectionAnswer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subjectId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInspectionAnswer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "subjectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInspectionAnswerMutation,
  DeleteInspectionAnswerMutationVariables
>;
export const ServiceCasesHeaderFragmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceCasesHeaderFragment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseWhereInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "Service_CaseDefinitionCaseFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceCasesHeaderFragmentQuery,
  ServiceCasesHeaderFragmentQueryVariables
>;
export const Service_AttachmentCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Service_AttachmentCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lang" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attachmentCategories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "lang" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lang" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameDa" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Service_AttachmentCategoriesQuery,
  Service_AttachmentCategoriesQueryVariables
>;
export const AttachmentCategorySelector_UpdateAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AttachmentCategorySelector_UpdateAttachment",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttachmentCategorySelector_UpdateAttachmentMutation,
  AttachmentCategorySelector_UpdateAttachmentMutationVariables
>;
export const TabTimeRegistration_AddTimeRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TabTimeRegistration_AddTimeRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TabTimeRegistration_AddTimeRegistrationMutation,
  TabTimeRegistration_AddTimeRegistrationMutationVariables
>;
export const TabTimeRegistration_UpdateTimeRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "TabTimeRegistration_UpdateTimeRegistration",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogAccountId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogCategoryId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ISO8601Date" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogHoursWithoutMinutes" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogMinutesWithoutHours" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogNote" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "timelogId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogAccountId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "categoryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogCategoryId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hoursWithoutMinutes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogHoursWithoutMinutes" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "minutesWithoutHours" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogMinutesWithoutHours" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogNote" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TabTimeRegistration_UpdateTimeRegistrationMutation,
  TabTimeRegistration_UpdateTimeRegistrationMutationVariables
>;
export const TabTimeRegistration_RemoveTimeRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "TabTimeRegistration_RemoveTimeRegistration",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timelogId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "timelogId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timelogId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TabTimeRegistration_RemoveTimeRegistrationMutation,
  TabTimeRegistration_RemoveTimeRegistrationMutationVariables
>;
export const ServiceCalendar_ScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ServiceCalendar_Schedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startAfter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "completeBefore" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scheduledDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scheduledTime" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "responsibleId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "casePlanningUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startAfter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startAfter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "completeBefore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "completeBefore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scheduledDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "scheduledDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scheduledTime" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "scheduledTime" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "responsibleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "responsibleId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceCalendar_ScheduleMutation,
  ServiceCalendar_ScheduleMutationVariables
>;
export const ServiceCalendar_UnassignedCasesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceCalendar_UnassignedCases" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseOrderByEnum" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ServiceCalendar_Case" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCalendar_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canChangeResponsible" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayChangeResponsible" },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceCalendar_UnassignedCasesQuery,
  ServiceCalendar_UnassignedCasesQueryVariables
>;
export const ServiceCalendar_ScheduledCasesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceCalendar_ScheduledCases" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ServiceCalendar_Case" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCalendar_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canChangeResponsible" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayChangeResponsible" },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeTask" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeTask" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceCalendar_ScheduledCasesQuery,
  ServiceCalendar_ScheduledCasesQueryVariables
>;
export const ServiceCalendar_ResponsibleOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceCalendar_ResponsibleOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableResponsibleUsers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceCalendar_ResponsibleOptionsQuery,
  ServiceCalendar_ResponsibleOptionsQueryVariables
>;
export const ServiceRootPageAddAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ServiceRootPageAddAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceRootPageAddAttachmentMutation,
  ServiceRootPageAddAttachmentMutationVariables
>;
export const ServiceRootPage_CaseByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceRootPage_CaseById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "commentTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "CaseCommentTypeEnum" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "byType" },
                value: {
                  kind: "ListValue",
                  values: [
                    { kind: "StringValue", value: "service", block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ServiceRootPage_Case" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "important" } },
          { kind: "Field", name: { kind: "Name", value: "readAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "fileType" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "stateFrom" } },
          { kind: "Field", name: { kind: "Name", value: "stateTo" } },
          { kind: "Field", name: { kind: "Name", value: "stateDescription" } },
          { kind: "Field", name: { kind: "Name", value: "smsMessage" } },
          { kind: "Field", name: { kind: "Name", value: "emailMessage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_CaseCommentUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseCommentUserOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "completedDate" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayAddComment" } },
          { kind: "Field", name: { kind: "Name", value: "canAwait" } },
          { kind: "Field", name: { kind: "Name", value: "mayAwait" } },
          { kind: "Field", name: { kind: "Name", value: "isArchived" } },
          { kind: "Field", name: { kind: "Name", value: "tenantWillAttend" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "comments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "commentTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "commentTypes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Service_CaseComment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "originalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameDa" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameEn" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableInService",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableInService",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "administrator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isService" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "whyAttention" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "texts" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commentUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ServiceRootPage_CaseCommentUser",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hoursWithoutMinutes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minutesWithoutHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "canDestroy" } },
                { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "mayCreate" } },
          { kind: "Field", name: { kind: "Name", value: "mayComplete" } },
          { kind: "Field", name: { kind: "Name", value: "mayCancel" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddComment" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddTimelog" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddFollower" } },
          { kind: "Field", name: { kind: "Name", value: "mayRemoveFollower" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayChangeResponsible" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayAddAttachment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayRemoveAttachment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayConfigureRepeat" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayToggleCheck" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
          { kind: "Field", name: { kind: "Name", value: "canComplete" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "canAddComment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canSendCommentAsSms" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddAttachment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRemoveAttachment" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddFollower" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveFollower" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canChangeResponsible" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddTimelog" } },
          { kind: "Field", name: { kind: "Name", value: "canToggleCheck" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canConfigureRepeat" },
          },
          { kind: "Field", name: { kind: "Name", value: "canShowTimelogs" } },
          { kind: "Field", name: { kind: "Name", value: "canShowAttention" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogAccount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceRootPage_CaseByIdQuery,
  ServiceRootPage_CaseByIdQueryVariables
>;
export const ServiceRootPage_CasesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceRootPage_Cases" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseOrderByEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "commentTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "CaseCommentTypeEnum" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ServiceRootPage_Case" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "Service_CaseDefinitionCaseFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_CaseComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "important" } },
          { kind: "Field", name: { kind: "Name", value: "readAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "fileType" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "stateFrom" } },
          { kind: "Field", name: { kind: "Name", value: "stateTo" } },
          { kind: "Field", name: { kind: "Name", value: "stateDescription" } },
          { kind: "Field", name: { kind: "Name", value: "smsMessage" } },
          { kind: "Field", name: { kind: "Name", value: "emailMessage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_CaseCommentUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseCommentUserOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRootPage_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Service_CaseDefinitionCaseFragment" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "completedDate" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unreadCommentsCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayAddComment" } },
          { kind: "Field", name: { kind: "Name", value: "canAwait" } },
          { kind: "Field", name: { kind: "Name", value: "mayAwait" } },
          { kind: "Field", name: { kind: "Name", value: "isArchived" } },
          { kind: "Field", name: { kind: "Name", value: "tenantWillAttend" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "comments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "commentTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "commentTypes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Service_CaseComment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "originalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "thumbUrl" } },
                { kind: "Field", name: { kind: "Name", value: "largeUrl" } },
                { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                { kind: "Field", name: { kind: "Name", value: "isImage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headSignedUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameDa" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameEn" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableInService",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableInService",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "administrator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isService" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "whyAttention" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "texts" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commentUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ServiceRootPage_CaseCommentUser",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hoursWithoutMinutes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minutesWithoutHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "canDestroy" } },
                { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "mayCreate" } },
          { kind: "Field", name: { kind: "Name", value: "mayComplete" } },
          { kind: "Field", name: { kind: "Name", value: "mayCancel" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddComment" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddTimelog" } },
          { kind: "Field", name: { kind: "Name", value: "mayAddFollower" } },
          { kind: "Field", name: { kind: "Name", value: "mayRemoveFollower" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayChangeResponsible" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayAddAttachment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayRemoveAttachment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mayConfigureRepeat" },
          },
          { kind: "Field", name: { kind: "Name", value: "mayToggleCheck" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
          { kind: "Field", name: { kind: "Name", value: "canComplete" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "canAddComment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canSendCommentAsSms" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddAttachment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRemoveAttachment" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddFollower" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveFollower" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canChangeResponsible" },
          },
          { kind: "Field", name: { kind: "Name", value: "canAddTimelog" } },
          { kind: "Field", name: { kind: "Name", value: "canToggleCheck" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canConfigureRepeat" },
          },
          { kind: "Field", name: { kind: "Name", value: "canShowTimelogs" } },
          { kind: "Field", name: { kind: "Name", value: "canShowAttention" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogAccount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayReceive" } },
                { kind: "Field", name: { kind: "Name", value: "canReceive" } },
                { kind: "Field", name: { kind: "Name", value: "maySchedule" } },
                { kind: "Field", name: { kind: "Name", value: "canSchedule" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canReschedule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayCancelScheduled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canCancelScheduled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceRootPage_CasesQuery,
  ServiceRootPage_CasesQueryVariables
>;
export const ServiceFiltersDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceFiltersData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teamId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "team" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teamId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "caseDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cases" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: {
                              kind: "Name",
                              value: "byAssignedServiceTeam",
                            },
                            value: {
                              kind: "ListValue",
                              values: [
                                {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "teamId" },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "byProperty" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "propertyIds" },
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "cancelled" },
                            value: { kind: "BooleanValue", value: false },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "completed" },
                            value: { kind: "BooleanValue", value: false },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ServiceFiltersDataQuery,
  ServiceFiltersDataQueryVariables
>;
export const Service_ServiceTeamPropertiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Service_ServiceTeamProperties" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PropertyWhereInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "Service_ServiceTeamProperty",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Service_ServiceTeamProperty" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "activeServiceCasesCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Service_ServiceTeamPropertiesQuery,
  Service_ServiceTeamPropertiesQueryVariables
>;
export const CurrentUser_ServiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CurrentUser_Service" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CurrentUserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CurrentUserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSystemAdministrator" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAdministrator" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceAdministrator" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceCaseWorker" },
          },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CurrentUser_ServiceQuery,
  CurrentUser_ServiceQueryVariables
>;
